!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"));else if ("function" == typeof define && define.amd) define(["react"], t);else {
    var r = t("object" == typeof exports ? require("react") : e.React);

    for (var n in r) {
      ("object" == typeof exports ? exports : e)[n] = r[n];
    }
  }
}(this, function (e) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var a = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.i = function (e) {
      return e;
    }, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/", t(t.s = 29);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(15)();
  }, function (e, t, r) {
    var n, a;
    /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      function r() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var a = typeof n;
            if ("string" === a || "number" === a) e.push(n);else if (Array.isArray(n) && n.length) {
              var i = r.apply(null, n);
              i && e.push(i);
            } else if ("object" === a) for (var s in n) {
              o.call(n, s) && n[s] && e.push(s);
            }
          }
        }

        return e.join(" ");
      }

      var o = {}.hasOwnProperty;
      void 0 !== e && e.exports ? (r.default = r, e.exports = r) : (n = [], void 0 !== (a = function () {
        return r;
      }.apply(t, n)) && (e.exports = a));
    }();
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      var r = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
      }

      return r;
    }

    function o(e, t, r) {
      if (!t) return e;
      var n = y(t),
          a = void 0;

      try {
        a = n.reduce(function (e, t) {
          return e[t];
        }, e);
      } catch (e) {}

      return void 0 !== a ? a : r;
    }

    function i() {
      for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments[1], r = arguments[2], n = y(t), a = void 0, o = e; (a = n.shift()) && n.length;) {
        o[a] || (o[a] = {}), o = o[a];
      }

      return o[a] = r, e;
    }

    function s(e, t) {
      var r = t > e.length ? 0 : e.length - t;
      return e.slice(r);
    }

    function l(e) {
      return e[e.length - 1];
    }

    function u(e) {
      for (var t = [], r = 0; r < e; r++) {
        t.push(e);
      }

      return t;
    }

    function p(e, t, r) {
      return e.sort(function (e, n) {
        for (var a = 0; a < t.length; a++) {
          var o = t[a],
              i = o(e),
              s = o(n),
              l = !1 === r[a] || "desc" === r[a];
          if (i > s) return l ? -1 : 1;
          if (i < s) return l ? 1 : -1;
        }

        return r[0] ? e.__index - n.__index : n.__index - e.__index;
      });
    }

    function f(e, t) {
      return e.filter(function (r, n) {
        return !!t(r) && (e.splice(n, 1), !0);
      });
    }

    function c(e) {
      try {
        return JSON.parse(JSON.stringify(e, function (e, t) {
          return "function" == typeof t ? t.toString() : t;
        }));
      } catch (t) {
        return e;
      }
    }

    function d() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }

      for (var n = 0; n < t.length; n++) {
        if (void 0 !== t[n]) return t[n];
      }
    }

    function h(e) {
      return e.reduce(function (e, t) {
        return e + t;
      }, 0);
    }

    function m(e) {
      return function (t) {
        var r = t.children,
            n = t.className,
            o = a(t, ["children", "className"]);
        return k.default.createElement("div", E({
          className: (0, T.default)(e, n)
        }, o), r);
      };
    }

    function g(e, t) {
      return e.reduce(function (e, r, n) {
        var a = "function" == typeof t ? t(r, n) : r[t];
        return e[a] = v(e[a]) ? e[a] : [], e[a].push(r), e;
      }, {});
    }

    function v(e) {
      return Array.isArray(e);
    }

    function y(e) {
      return b(e).join(".").replace("[", ".").replace("]", "").split(".");
    }

    function b(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      if (v(e)) for (var r = 0; r < e.length; r++) {
        b(e[r], t);
      } else t.push(e);
      return t;
    }

    function C(e) {
      return {
        className: e.className,
        style: e.style,
        rest: a(e, ["className", "style"])
      };
    }

    function _(e) {
      var t = {};

      for (var r in e) {
        e.hasOwnProperty(r) && void 0 !== e[r] && void 0 !== e[r] && (t[r] = e[r]);
      }

      return t;
    }

    function w(e) {
      return !("desc" !== e.sort && !0 !== e.desc && !1 !== e.asc);
    }

    function x(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e;
      return "function" == typeof e ? Object.getPrototypeOf(e).isReactComponent ? k.default.createElement(e, t) : e(t) : r;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var E = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        S = r(0),
        k = n(S),
        P = r(2),
        T = n(P);

    t.default = {
      get: o,
      set: i,
      takeRight: s,
      last: l,
      orderBy: p,
      range: u,
      remove: f,
      clone: c,
      getFirstDefined: d,
      sum: h,
      makeTemplateComponent: m,
      groupBy: g,
      isArray: v,
      splitProps: C,
      compactObject: _,
      isSortingDesc: w,
      normalizeComponent: x
    };
  }, function (e, t) {
    e.exports = function () {
      var e = [];
      return e.toString = function () {
        for (var e = [], t = 0; t < this.length; t++) {
          var r = this[t];
          r[2] ? e.push("@media " + r[2] + "{" + r[1] + "}") : e.push(r[1]);
        }

        return e.join("");
      }, e.i = function (t, r) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var n = {}, a = 0; a < this.length; a++) {
          var o = this[a][0];
          "number" == typeof o && (n[o] = !0);
        }

        for (a = 0; a < t.length; a++) {
          var i = t[a];
          "number" == typeof i[0] && n[i[0]] || (r && !i[2] ? i[2] = r : r && (i[2] = "(" + i[2] + ") and (" + r + ")"), e.push(i));
        }
      }, e;
    };
  }, function (e, t) {
    function r(e, t) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r],
            a = c[n.id];

        if (a) {
          a.refs++;

          for (var o = 0; o < a.parts.length; o++) {
            a.parts[o](n.parts[o]);
          }

          for (; o < n.parts.length; o++) {
            a.parts.push(l(n.parts[o], t));
          }
        } else {
          for (var i = [], o = 0; o < n.parts.length; o++) {
            i.push(l(n.parts[o], t));
          }

          c[n.id] = {
            id: n.id,
            refs: 1,
            parts: i
          };
        }
      }
    }

    function n(e) {
      for (var t = [], r = {}, n = 0; n < e.length; n++) {
        var a = e[n],
            o = a[0],
            i = a[1],
            s = a[2],
            l = a[3],
            u = {
          css: i,
          media: s,
          sourceMap: l
        };
        r[o] ? r[o].parts.push(u) : t.push(r[o] = {
          id: o,
          parts: [u]
        });
      }

      return t;
    }

    function a(e, t) {
      var r = m(),
          n = y[y.length - 1];
      if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), y.push(t);else {
        if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
        r.appendChild(t);
      }
    }

    function o(e) {
      e.parentNode.removeChild(e);
      var t = y.indexOf(e);
      t >= 0 && y.splice(t, 1);
    }

    function i(e) {
      var t = document.createElement("style");
      return t.type = "text/css", a(e, t), t;
    }

    function s(e) {
      var t = document.createElement("link");
      return t.rel = "stylesheet", a(e, t), t;
    }

    function l(e, t) {
      var r, n, a;

      if (t.singleton) {
        var l = v++;
        r = g || (g = i(t)), n = u.bind(null, r, l, !1), a = u.bind(null, r, l, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (r = s(t), n = f.bind(null, r), a = function a() {
        o(r), r.href && URL.revokeObjectURL(r.href);
      }) : (r = i(t), n = p.bind(null, r), a = function a() {
        o(r);
      });

      return n(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else a();
      };
    }

    function u(e, t, r, n) {
      var a = r ? "" : n.css;
      if (e.styleSheet) e.styleSheet.cssText = b(t, a);else {
        var o = document.createTextNode(a),
            i = e.childNodes;
        i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(o, i[t]) : e.appendChild(o);
      }
    }

    function p(e, t) {
      var r = t.css,
          n = t.media;
      if (n && e.setAttribute("media", n), e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(r));
      }
    }

    function f(e, t) {
      var r = t.css,
          n = t.sourceMap;
      n && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(n)))) + " */");
      var a = new Blob([r], {
        type: "text/css"
      }),
          o = e.href;
      e.href = URL.createObjectURL(a), o && URL.revokeObjectURL(o);
    }

    var c = {},
        d = function d(e) {
      var t;
      return function () {
        return void 0 === t && (t = e.apply(this, arguments)), t;
      };
    },
        h = d(function () {
      return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
    }),
        m = d(function () {
      return document.head || document.getElementsByTagName("head")[0];
    }),
        g = null,
        v = 0,
        y = [];

    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      t = t || {}, void 0 === t.singleton && (t.singleton = h()), void 0 === t.insertAt && (t.insertAt = "bottom");
      var a = n(e);
      return r(a, t), function (e) {
        for (var o = [], i = 0; i < a.length; i++) {
          var s = a[i],
              l = c[s.id];
          l.refs--, o.push(l);
        }

        if (e) {
          r(n(e), t);
        }

        for (var i = 0; i < o.length; i++) {
          var l = o[i];

          if (0 === l.refs) {
            for (var u = 0; u < l.parts.length; u++) {
              l.parts[u]();
            }

            delete c[l.id];
          }
        }
      };
    };

    var b = function () {
      var e = [];
      return function (t, r) {
        return e[t] = r, e.filter(Boolean).join("\n");
      };
    }();
  }, function (e, t, r) {
    var n,
        a = function a(e) {
      function t() {
        le = new Array(128), ue = {
          w: F,
          b: F
        }, pe = A, fe = {
          w: 0,
          b: 0
        }, ce = F, de = 0, he = 1, me = [], ge = {}, s(o());
      }

      function r() {
        n(G);
      }

      function n(e) {
        var r = e.split(/\s+/),
            n = r[0],
            i = 0;
        if (!a(e).valid) return !1;
        t();

        for (var l = 0; l < n.length; l++) {
          var p = n.charAt(l);
          if ("/" === p) i += 8;else if (N(p)) i += parseInt(p, 10);else {
            var f = p < "a" ? A : D;
            u({
              type: p.toLowerCase(),
              color: f
            }, O(i)), i++;
          }
        }

        return pe = r[1], r[2].indexOf("K") > -1 && (fe.w |= te.KSIDE_CASTLE), r[2].indexOf("Q") > -1 && (fe.w |= te.QSIDE_CASTLE), r[2].indexOf("k") > -1 && (fe.b |= te.KSIDE_CASTLE), r[2].indexOf("q") > -1 && (fe.b |= te.QSIDE_CASTLE), ce = "-" === r[3] ? F : ie[r[3]], de = parseInt(r[4], 10), he = parseInt(r[5], 10), s(o()), !0;
      }

      function a(e) {
        var t = {
          0: "No errors.",
          1: "FEN string must contain six space-delimited fields.",
          2: "6th field (move number) must be a positive integer.",
          3: "5th field (half move counter) must be a non-negative integer.",
          4: "4th field (en-passant square) is invalid.",
          5: "3rd field (castling availability) is invalid.",
          6: "2nd field (side to move) is invalid.",
          7: "1st field (piece positions) does not contain 8 '/'-delimited rows.",
          8: "1st field (piece positions) is invalid [consecutive numbers].",
          9: "1st field (piece positions) is invalid [invalid piece].",
          10: "1st field (piece positions) is invalid [row too large].",
          11: "Illegal en-passant square"
        },
            r = e.split(/\s+/);
        if (6 !== r.length) return {
          valid: !1,
          error_number: 1,
          error: t[1]
        };
        if (isNaN(r[5]) || parseInt(r[5], 10) <= 0) return {
          valid: !1,
          error_number: 2,
          error: t[2]
        };
        if (isNaN(r[4]) || parseInt(r[4], 10) < 0) return {
          valid: !1,
          error_number: 3,
          error: t[3]
        };
        if (!/^(-|[abcdefgh][36])$/.test(r[3])) return {
          valid: !1,
          error_number: 4,
          error: t[4]
        };
        if (!/^(KQ?k?q?|Qk?q?|kq?|q|-)$/.test(r[2])) return {
          valid: !1,
          error_number: 5,
          error: t[5]
        };
        if (!/^(w|b)$/.test(r[1])) return {
          valid: !1,
          error_number: 6,
          error: t[6]
        };
        var n = r[0].split("/");
        if (8 !== n.length) return {
          valid: !1,
          error_number: 7,
          error: t[7]
        };

        for (var a = 0; a < n.length; a++) {
          for (var o = 0, i = !1, s = 0; s < n[a].length; s++) {
            if (isNaN(n[a][s])) {
              if (!/^[prnbqkPRNBQK]$/.test(n[a][s])) return {
                valid: !1,
                error_number: 9,
                error: t[9]
              };
              o += 1, i = !1;
            } else {
              if (i) return {
                valid: !1,
                error_number: 8,
                error: t[8]
              };
              o += parseInt(n[a][s], 10), i = !0;
            }
          }

          if (8 !== o) return {
            valid: !1,
            error_number: 10,
            error: t[10]
          };
        }

        return "3" == r[3][1] && "w" == r[1] || "6" == r[3][1] && "b" == r[1] ? {
          valid: !1,
          error_number: 11,
          error: t[11]
        } : {
          valid: !0,
          error_number: 0,
          error: t[0]
        };
      }

      function o() {
        for (var e = 0, t = "", r = ie.a8; r <= ie.h1; r++) {
          if (null == le[r]) e++;else {
            e > 0 && (t += e, e = 0);
            var n = le[r].color,
                a = le[r].type;
            t += n === A ? a.toUpperCase() : a.toLowerCase();
          }
          r + 1 & 136 && (e > 0 && (t += e), r !== ie.h1 && (t += "/"), e = 0, r += 8);
        }

        var o = "";
        fe[A] & te.KSIDE_CASTLE && (o += "K"), fe[A] & te.QSIDE_CASTLE && (o += "Q"), fe[D] & te.KSIDE_CASTLE && (o += "k"), fe[D] & te.QSIDE_CASTLE && (o += "q"), o = o || "-";
        var i = ce === F ? "-" : O(ce);
        return [t, pe, o, i, de, he].join(" ");
      }

      function i(e) {
        for (var t = 0; t < e.length; t += 2) {
          "string" == typeof e[t] && "string" == typeof e[t + 1] && (ge[e[t]] = e[t + 1]);
        }

        return ge;
      }

      function s(e) {
        me.length > 0 || (e !== G ? (ge.SetUp = "1", ge.FEN = e) : (delete ge.SetUp, delete ge.FEN));
      }

      function l(e) {
        var t = le[ie[e]];
        return t ? {
          type: t.type,
          color: t.color
        } : null;
      }

      function u(e, t) {
        if (!("type" in e && "color" in e)) return !1;
        if (-1 === Q.indexOf(e.type.toLowerCase())) return !1;
        if (!(t in ie)) return !1;
        var r = ie[t];
        return (e.type != B || ue[e.color] == F || ue[e.color] == r) && (le[r] = {
          type: e.type,
          color: e.color
        }, e.type === B && (ue[e.color] = r), s(o()), !0);
      }

      function p(e) {
        var t = l(e);
        return le[ie[e]] = null, t && t.type === B && (ue[t.color] = F), s(o()), t;
      }

      function f(e, t, r, n, a) {
        var o = {
          color: pe,
          from: t,
          to: r,
          flags: n,
          piece: e[t].type
        };
        return a && (o.flags |= te.PROMOTION, o.promotion = a), e[r] ? o.captured = e[r].type : n & te.EP_CAPTURE && (o.captured = I), o;
      }

      function c(e) {
        function t(e, t, r, n, a) {
          if (e[r].type !== I || T(n) !== oe && T(n) !== re) t.push(f(e, r, n, a));else for (var o = [H, K, U, W], i = 0, s = o.length; i < s; i++) {
            t.push(f(e, r, n, a, o[i]));
          }
        }

        var r = [],
            n = pe,
            a = z(n),
            o = {
          b: ae,
          w: ne
        },
            i = ie.a8,
            s = ie.h1,
            l = !1,
            u = !(void 0 !== e && "legal" in e) || e.legal;

        if (void 0 !== e && "square" in e) {
          if (!(e.square in ie)) return [];
          i = s = ie[e.square], l = !0;
        }

        for (var p = i; p <= s; p++) {
          if (136 & p) p += 7;else {
            var c = le[p];
            if (null != c && c.color === n) if (c.type === I) {
              var d = p + V[n][0];

              if (null == le[d]) {
                t(le, r, p, d, te.NORMAL);
                var d = p + V[n][1];
                o[n] === T(p) && null == le[d] && t(le, r, p, d, te.BIG_PAWN);
              }

              for (h = 2; h < 4; h++) {
                var d = p + V[n][h];
                136 & d || (null != le[d] && le[d].color === a ? t(le, r, p, d, te.CAPTURE) : d === ce && t(le, r, p, ce, te.EP_CAPTURE));
              }
            } else for (var h = 0, v = X[c.type].length; h < v; h++) {
              for (var y = X[c.type][h], d = p;;) {
                if (136 & (d += y)) break;

                if (null != le[d]) {
                  if (le[d].color === n) break;
                  t(le, r, p, d, te.CAPTURE);
                  break;
                }

                if (t(le, r, p, d, te.NORMAL), "n" === c.type || "k" === c.type) break;
              }
            }
          }
        }

        if (!l || s === ue[n]) {
          if (fe[n] & te.KSIDE_CASTLE) {
            var b = ue[n],
                C = b + 2;
            null != le[b + 1] || null != le[C] || m(a, ue[n]) || m(a, b + 1) || m(a, C) || t(le, r, ue[n], C, te.KSIDE_CASTLE);
          }

          if (fe[n] & te.QSIDE_CASTLE) {
            var b = ue[n],
                C = b - 2;
            null != le[b - 1] || null != le[b - 2] || null != le[b - 3] || m(a, ue[n]) || m(a, b - 1) || m(a, C) || t(le, r, ue[n], C, te.QSIDE_CASTLE);
          }
        }

        if (!u) return r;

        for (var _ = [], p = 0, v = r.length; p < v; p++) {
          x(r[p]), g(n) || _.push(r[p]), E();
        }

        return _;
      }

      function d(e, t) {
        var r = "";
        if (e.flags & te.KSIDE_CASTLE) r = "O-O";else if (e.flags & te.QSIDE_CASTLE) r = "O-O-O";else {
          var n = S(e, t);
          e.piece !== I && (r += e.piece.toUpperCase() + n), e.flags & (te.CAPTURE | te.EP_CAPTURE) && (e.piece === I && (r += O(e.from)[0]), r += "x"), r += O(e.to), e.flags & te.PROMOTION && (r += "=" + e.promotion.toUpperCase());
        }
        return x(e), v() && (y() ? r += "#" : r += "+"), E(), r;
      }

      function h(e) {
        return e.replace(/=/, "").replace(/[+#]?[?!]*$/, "");
      }

      function m(e, t) {
        for (var r = ie.a8; r <= ie.h1; r++) {
          if (136 & r) r += 7;else if (null != le[r] && le[r].color === e) {
            var n = le[r],
                a = r - t,
                o = a + 119;

            if (Y[o] & 1 << Z[n.type]) {
              if (n.type === I) {
                if (a > 0) {
                  if (n.color === A) return !0;
                } else if (n.color === D) return !0;

                continue;
              }

              if ("n" === n.type || "k" === n.type) return !0;

              for (var i = J[o], s = r + i, l = !1; s !== t;) {
                if (null != le[s]) {
                  l = !0;
                  break;
                }

                s += i;
              }

              if (!l) return !0;
            }
          }
        }

        return !1;
      }

      function g(e) {
        return m(z(e), ue[e]);
      }

      function v() {
        return g(pe);
      }

      function y() {
        return v() && 0 === c().length;
      }

      function b() {
        return !v() && 0 === c().length;
      }

      function C() {
        for (var e = {}, t = [], r = 0, n = 0, a = ie.a8; a <= ie.h1; a++) {
          if (n = (n + 1) % 2, 136 & a) a += 7;else {
            var o = le[a];
            o && (e[o.type] = o.type in e ? e[o.type] + 1 : 1, o.type === U && t.push(n), r++);
          }
        }

        if (2 === r) return !0;
        if (3 === r && (1 === e[U] || 1 === e[W])) return !0;

        if (r === e[U] + 2) {
          for (var i = 0, s = t.length, a = 0; a < s; a++) {
            i += t[a];
          }

          if (0 === i || i === s) return !0;
        }

        return !1;
      }

      function _() {
        for (var e = [], t = {}, r = !1;;) {
          var n = E();
          if (!n) break;
          e.push(n);
        }

        for (;;) {
          var a = o().split(" ").slice(0, 4).join(" ");
          if (t[a] = a in t ? t[a] + 1 : 1, t[a] >= 3 && (r = !0), !e.length) break;
          x(e.pop());
        }

        return r;
      }

      function w(e) {
        me.push({
          move: e,
          kings: {
            b: ue.b,
            w: ue.w
          },
          turn: pe,
          castling: {
            b: fe.b,
            w: fe.w
          },
          ep_square: ce,
          half_moves: de,
          move_number: he
        });
      }

      function x(e) {
        var t = pe,
            r = z(t);

        if (w(e), le[e.to] = le[e.from], le[e.from] = null, e.flags & te.EP_CAPTURE && (pe === D ? le[e.to - 16] = null : le[e.to + 16] = null), e.flags & te.PROMOTION && (le[e.to] = {
          type: e.promotion,
          color: t
        }), le[e.to].type === B) {
          if (ue[le[e.to].color] = e.to, e.flags & te.KSIDE_CASTLE) {
            var n = e.to - 1,
                a = e.to + 1;
            le[n] = le[a], le[a] = null;
          } else if (e.flags & te.QSIDE_CASTLE) {
            var n = e.to + 1,
                a = e.to - 2;
            le[n] = le[a], le[a] = null;
          }

          fe[t] = "";
        }

        if (fe[t]) for (var o = 0, i = se[t].length; o < i; o++) {
          if (e.from === se[t][o].square && fe[t] & se[t][o].flag) {
            fe[t] ^= se[t][o].flag;
            break;
          }
        }
        if (fe[r]) for (var o = 0, i = se[r].length; o < i; o++) {
          if (e.to === se[r][o].square && fe[r] & se[r][o].flag) {
            fe[r] ^= se[r][o].flag;
            break;
          }
        }
        ce = e.flags & te.BIG_PAWN ? "b" === pe ? e.to - 16 : e.to + 16 : F, e.piece === I ? de = 0 : e.flags & (te.CAPTURE | te.EP_CAPTURE) ? de = 0 : de++, pe === D && he++, pe = z(pe);
      }

      function E() {
        var e = me.pop();
        if (null == e) return null;
        var t = e.move;
        ue = e.kings, pe = e.turn, fe = e.castling, ce = e.ep_square, de = e.half_moves, he = e.move_number;
        var r = pe,
            n = z(pe);
        if (le[t.from] = le[t.to], le[t.from].type = t.piece, le[t.to] = null, t.flags & te.CAPTURE) le[t.to] = {
          type: t.captured,
          color: n
        };else if (t.flags & te.EP_CAPTURE) {
          var a;
          a = r === D ? t.to - 16 : t.to + 16, le[a] = {
            type: I,
            color: n
          };
        }

        if (t.flags & (te.KSIDE_CASTLE | te.QSIDE_CASTLE)) {
          var o, i;
          t.flags & te.KSIDE_CASTLE ? (o = t.to + 1, i = t.to - 1) : t.flags & te.QSIDE_CASTLE && (o = t.to - 2, i = t.to + 1), le[o] = le[i], le[i] = null;
        }

        return t;
      }

      function S(e, t) {
        for (var r = c({
          legal: !t
        }), n = e.from, a = e.to, o = e.piece, i = 0, s = 0, l = 0, u = 0, p = r.length; u < p; u++) {
          var f = r[u].from,
              d = r[u].to;
          o === r[u].piece && n !== f && a === d && (i++, T(n) === T(f) && s++, R(n) === R(f) && l++);
        }

        return i > 0 ? s > 0 && l > 0 ? O(n) : l > 0 ? O(n).charAt(1) : O(n).charAt(0) : "";
      }

      function k() {
        for (var e = "   +------------------------+\n", t = ie.a8; t <= ie.h1; t++) {
          if (0 === R(t) && (e += " " + "87654321"[T(t)] + " |"), null == le[t]) e += " . ";else {
            var r = le[t].type;
            e += " " + (le[t].color === A ? r.toUpperCase() : r.toLowerCase()) + " ";
          }
          t + 1 & 136 && (e += "|\n", t += 8);
        }

        return e += "   +------------------------+\n", e += "     a  b  c  d  e  f  g  h\n";
      }

      function P(e, t) {
        var r = h(e);

        if (t) {
          var n = r.match(/([pnbrqkPNBRQK])?([a-h][1-8])x?-?([a-h][1-8])([qrbnQRBN])?/);
          if (n) var a = n[1],
              o = n[2],
              i = n[3],
              s = n[4];
        }

        for (var l = c(), u = 0, p = l.length; u < p; u++) {
          if (r === h(d(l[u])) || t && r === h(d(l[u], !0))) return l[u];
          if (n && (!a || a.toLowerCase() == l[u].piece) && ie[o] == l[u].from && ie[i] == l[u].to && (!s || s.toLowerCase() == l[u].promotion)) return l[u];
        }

        return null;
      }

      function T(e) {
        return e >> 4;
      }

      function R(e) {
        return 15 & e;
      }

      function O(e) {
        var t = R(e),
            r = T(e);
        return "abcdefgh".substring(t, t + 1) + "87654321".substring(r, r + 1);
      }

      function z(e) {
        return e === A ? D : A;
      }

      function N(e) {
        return -1 !== "0123456789".indexOf(e);
      }

      function M(e) {
        var t = q(e);
        t.san = d(t, !1), t.to = O(t.to), t.from = O(t.from);
        var r = "";

        for (var n in te) {
          te[n] & t.flags && (r += ee[n]);
        }

        return t.flags = r, t;
      }

      function q(e) {
        var t = e instanceof Array ? [] : {};

        for (var r in e) {
          t[r] = "object" == typeof r ? q(e[r]) : e[r];
        }

        return t;
      }

      function L(e) {
        return e.replace(/^\s+|\s+$/g, "");
      }

      function j(e) {
        for (var t = c({
          legal: !1
        }), r = 0, n = pe, a = 0, o = t.length; a < o; a++) {
          if (x(t[a]), !g(n)) if (e - 1 > 0) {
            var i = j(e - 1);
            r += i;
          } else r++;
          E();
        }

        return r;
      }

      var D = "b",
          A = "w",
          F = -1,
          I = "p",
          W = "n",
          U = "b",
          K = "r",
          H = "q",
          B = "k",
          Q = "pnbrqkPNBRQK",
          G = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1",
          $ = ["1-0", "0-1", "1/2-1/2", "*"],
          V = {
        b: [16, 32, 17, 15],
        w: [-16, -32, -17, -15]
      },
          X = {
        n: [-18, -33, -31, -14, 18, 33, 31, 14],
        b: [-17, -15, 17, 15],
        r: [-16, 1, 16, -1],
        q: [-17, -16, -15, 1, 17, 16, 15, -1],
        k: [-17, -16, -15, 1, 17, 16, 15, -1]
      },
          Y = [20, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 20, 0, 0, 20, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 20, 0, 0, 0, 0, 24, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 24, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 24, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 24, 2, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 53, 56, 53, 2, 0, 0, 0, 0, 0, 0, 24, 24, 24, 24, 24, 24, 56, 0, 56, 24, 24, 24, 24, 24, 24, 0, 0, 0, 0, 0, 0, 2, 53, 56, 53, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 24, 2, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 24, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 24, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 24, 0, 0, 0, 0, 20, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 20, 0, 0, 20, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 20],
          J = [17, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 15, 0, 0, 17, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 17, 0, 0, 0, 0, 16, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 16, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 16, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17, 0, 16, 0, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17, 16, 15, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, -15, -16, -17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -15, 0, -16, 0, -17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -15, 0, 0, -16, 0, 0, -17, 0, 0, 0, 0, 0, 0, 0, 0, -15, 0, 0, 0, -16, 0, 0, 0, -17, 0, 0, 0, 0, 0, 0, -15, 0, 0, 0, 0, -16, 0, 0, 0, 0, -17, 0, 0, 0, 0, -15, 0, 0, 0, 0, 0, -16, 0, 0, 0, 0, 0, -17, 0, 0, -15, 0, 0, 0, 0, 0, 0, -16, 0, 0, 0, 0, 0, 0, -17],
          Z = {
        p: 0,
        n: 1,
        b: 2,
        r: 3,
        q: 4,
        k: 5
      },
          ee = {
        NORMAL: "n",
        CAPTURE: "c",
        BIG_PAWN: "b",
        EP_CAPTURE: "e",
        PROMOTION: "p",
        KSIDE_CASTLE: "k",
        QSIDE_CASTLE: "q"
      },
          te = {
        NORMAL: 1,
        CAPTURE: 2,
        BIG_PAWN: 4,
        EP_CAPTURE: 8,
        PROMOTION: 16,
        KSIDE_CASTLE: 32,
        QSIDE_CASTLE: 64
      },
          re = 7,
          ne = 6,
          ae = 1,
          oe = 0,
          ie = {
        a8: 0,
        b8: 1,
        c8: 2,
        d8: 3,
        e8: 4,
        f8: 5,
        g8: 6,
        h8: 7,
        a7: 16,
        b7: 17,
        c7: 18,
        d7: 19,
        e7: 20,
        f7: 21,
        g7: 22,
        h7: 23,
        a6: 32,
        b6: 33,
        c6: 34,
        d6: 35,
        e6: 36,
        f6: 37,
        g6: 38,
        h6: 39,
        a5: 48,
        b5: 49,
        c5: 50,
        d5: 51,
        e5: 52,
        f5: 53,
        g5: 54,
        h5: 55,
        a4: 64,
        b4: 65,
        c4: 66,
        d4: 67,
        e4: 68,
        f4: 69,
        g4: 70,
        h4: 71,
        a3: 80,
        b3: 81,
        c3: 82,
        d3: 83,
        e3: 84,
        f3: 85,
        g3: 86,
        h3: 87,
        a2: 96,
        b2: 97,
        c2: 98,
        d2: 99,
        e2: 100,
        f2: 101,
        g2: 102,
        h2: 103,
        a1: 112,
        b1: 113,
        c1: 114,
        d1: 115,
        e1: 116,
        f1: 117,
        g1: 118,
        h1: 119
      },
          se = {
        w: [{
          square: ie.a1,
          flag: te.QSIDE_CASTLE
        }, {
          square: ie.h1,
          flag: te.KSIDE_CASTLE
        }],
        b: [{
          square: ie.a8,
          flag: te.QSIDE_CASTLE
        }, {
          square: ie.h8,
          flag: te.KSIDE_CASTLE
        }]
      },
          le = new Array(128),
          ue = {
        w: F,
        b: F
      },
          pe = A,
          fe = {
        w: 0,
        b: 0
      },
          ce = F,
          de = 0,
          he = 1,
          me = [],
          ge = {};
      return n(void 0 === e ? G : e), {
        WHITE: A,
        BLACK: D,
        PAWN: I,
        KNIGHT: W,
        BISHOP: U,
        ROOK: K,
        QUEEN: H,
        KING: B,
        SQUARES: function () {
          for (var e = [], t = ie.a8; t <= ie.h1; t++) {
            136 & t ? t += 7 : e.push(O(t));
          }

          return e;
        }(),
        FLAGS: ee,
        load: function load(e) {
          return n(e);
        },
        reset: function reset() {
          return r();
        },
        moves: function moves(e) {
          for (var t = c(e), r = [], n = 0, a = t.length; n < a; n++) {
            void 0 !== e && "verbose" in e && e.verbose ? r.push(M(t[n])) : r.push(d(t[n], !1));
          }

          return r;
        },
        in_check: function in_check() {
          return v();
        },
        in_checkmate: function in_checkmate() {
          return y();
        },
        in_stalemate: function in_stalemate() {
          return b();
        },
        in_draw: function in_draw() {
          return de >= 100 || b() || C() || _();
        },
        insufficient_material: function insufficient_material() {
          return C();
        },
        in_threefold_repetition: function in_threefold_repetition() {
          return _();
        },
        game_over: function game_over() {
          return de >= 100 || y() || b() || C() || _();
        },
        validate_fen: function validate_fen(e) {
          return a(e);
        },
        fen: function fen() {
          return o();
        },
        pgn: function pgn(e) {
          var t = "object" == typeof e && "string" == typeof e.newline_char ? e.newline_char : "\n",
              r = "object" == typeof e && "number" == typeof e.max_width ? e.max_width : 0,
              n = [],
              a = !1;

          for (var o in ge) {
            n.push("[" + o + ' "' + ge[o] + '"]' + t), a = !0;
          }

          a && me.length && n.push(t);

          for (var i = []; me.length > 0;) {
            i.push(E());
          }

          for (var s = [], l = ""; i.length > 0;) {
            var u = i.pop();
            me.length || "b" !== u.color ? "w" === u.color && (l.length && s.push(l), l = he + ".") : l = he + ". ...", l = l + " " + d(u, !1), x(u);
          }

          if (l.length && s.push(l), void 0 !== ge.Result && s.push(ge.Result), 0 === r) return n.join("") + s.join(" ");

          for (var p = 0, o = 0; o < s.length; o++) {
            p + s[o].length > r && 0 !== o ? (" " === n[n.length - 1] && n.pop(), n.push(t), p = 0) : 0 !== o && (n.push(" "), p++), n.push(s[o]), p += s[o].length;
          }

          return n.join("");
        },
        load_pgn: function load_pgn(e, t) {
          function a(e) {
            return e.replace(/\\/g, "\\");
          }

          var o = void 0 !== t && "sloppy" in t && t.sloppy,
              s = "object" == typeof t && "string" == typeof t.newline_char ? t.newline_char : "\r?\n",
              l = new RegExp("^(\\[(.|" + a(s) + ")*\\])(" + a(s) + ")*1.(" + a(s) + "|.)*$", "g"),
              u = e.replace(l, "$1");
          "[" !== u[0] && (u = ""), r();

          var p = function (e, t) {
            for (var r = "object" == typeof t && "string" == typeof t.newline_char ? t.newline_char : "\r?\n", n = {}, o = e.split(new RegExp(a(r))), i = "", s = "", l = 0; l < o.length; l++) {
              i = o[l].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, "$1"), s = o[l].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, "$1"), L(i).length > 0 && (n[i] = s);
            }

            return n;
          }(u, t);

          for (var f in p) {
            i([f, p[f]]);
          }

          if ("1" === p.SetUp && !("FEN" in p && n(p.FEN))) return !1;
          var c = e.replace(u, "").replace(new RegExp(a(s), "g"), " ");
          c = c.replace(/(\{[^}]+\})+?/g, "");

          for (var d = /(\([^\(\)]+\))+?/g; d.test(c);) {
            c = c.replace(d, "");
          }

          c = c.replace(/\d+\.(\.\.)?/g, ""), c = c.replace(/\.\.\./g, ""), c = c.replace(/\$\d+/g, "");
          var h = L(c).split(new RegExp(/\s+/));
          h = h.join(",").replace(/,,+/g, ",").split(",");

          for (var m = "", g = 0; g < h.length - 1; g++) {
            if (null == (m = P(h[g], o))) return !1;
            x(m);
          }

          if (m = h[h.length - 1], $.indexOf(m) > -1) (function (e) {
            for (var t in e) {
              return !0;
            }

            return !1;
          })(ge) && void 0 === ge.Result && i(["Result", m]);else {
            if (null == (m = P(m, o))) return !1;
            x(m);
          }
          return !0;
        },
        header: function header() {
          return i(arguments);
        },
        ascii: function ascii() {
          return k();
        },
        turn: function turn() {
          return pe;
        },
        move: function move(e, t) {
          var r = void 0 !== t && "sloppy" in t && t.sloppy,
              n = null;
          if ("string" == typeof e) n = P(e, r);else if ("object" == typeof e) for (var a = c(), o = 0, i = a.length; o < i; o++) {
            if (!(e.from !== O(a[o].from) || e.to !== O(a[o].to) || "promotion" in a[o] && e.promotion !== a[o].promotion)) {
              n = a[o];
              break;
            }
          }
          if (!n) return null;
          var s = M(n);
          return x(n), s;
        },
        undo: function undo() {
          var e = E();
          return e ? M(e) : null;
        },
        clear: function clear() {
          return t();
        },
        put: function put(e, t) {
          return u(e, t);
        },
        get: function get(e) {
          return l(e);
        },
        remove: function remove(e) {
          return p(e);
        },
        perft: function perft(e) {
          return j(e);
        },
        square_color: function square_color(e) {
          if (e in ie) {
            var t = ie[e];
            return (T(t) + R(t)) % 2 == 0 ? "light" : "dark";
          }

          return null;
        },
        history: function history(e) {
          for (var t = [], r = [], n = void 0 !== e && ("verbose" in e) && e.verbose; me.length > 0;) {
            t.push(E());
          }

          for (; t.length > 0;) {
            var a = t.pop();
            n ? r.push(M(a)) : r.push(d(a)), x(a);
          }

          return r;
        }
      };
    };

    t.Chess = a, void 0 !== (n = function () {
      return a;
    }.call(t, r, t, e)) && (e.exports = n);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        l = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        u = r(0),
        p = n(u),
        f = r(8),
        c = n(f),
        d = r(9),
        h = n(d),
        m = r(1),
        g = n(m),
        v = function (e) {
      function t(e) {
        a(this, t);
        var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
            n = e.fen ? Array.isArray(e.fen) ? e.fen : [e.fen] : e.pgn ? e.getFensFromPgn(e.pgn) : [""],
            i = e.pgn ? "last" === e.startMove ? n.length - 1 : e.startMove : 0;
        return r.state = {
          currentMove: i,
          moves: n
        }, r;
      }

      return i(t, e), l(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          if (e.fen && e.fen !== this.props.fen && this.setState({
            currentMove: 0,
            moves: [e.fen]
          }), e.pgn && e.pgn !== this.props.pgn) {
            var t = e.getFensFromPgn(e.pgn);
            this.setState({
              currentMove: "last" === e.startMove ? t.length - 1 : e.startMove,
              moves: t
            });
          }
        }
      }, {
        key: "_onMovePiece",
        value: function value(e, t, r) {
          this.props.allowMoves && this.props.onMovePiece && this.props.onMovePiece(e, t, r);
        }
      }, {
        key: "_onMovePgnHead",
        value: function value(e) {
          this.setState({
            currentMove: e
          });
        }
      }, {
        key: "render",
        value: function value() {
          return p.default.createElement("div", null, p.default.createElement(c.default, s({}, this.props, {
            fen: this.state.moves[this.state.currentMove],
            style: {
              display: "inline-block"
            },
            onMovePiece: this._onMovePiece.bind(this)
          })), this.props.gameHistory ? p.default.createElement(h.default, {
            currentMove: this.state.currentMove,
            getHeader: this.props.getHeader,
            getMovetext: this.props.getMovetext,
            getResult: this.props.getResult,
            getRows: this.props.getRows,
            moveHead: this._onMovePgnHead.bind(this),
            newlineChar: this.props.newlineChar,
            pgn: this.props.pgn,
            style: {
              display: "inline-block"
            }
          }) : null);
        }
      }, {
        key: "startMove",
        get: function get() {
          if ("last" === this.props.startMove) return this.state.moves.length - 1;
          return "number" == typeof this.props.startMove || parseInt(this.props.startMove) ? parseInt(this.props.startMove) : 2 * (parseInt(this.props.startMove.slice(1)) - 1) + ("w" === this.props.startMove[0] ? 1 : 2);
        }
      }]), t;
    }(u.Component);

    v.propTypes = {
      allowMoves: g.default.bool,
      darkSquareColor: g.default.string,
      fen: g.default.oneOfType([g.default.string, g.default.array]),
      files: g.default.number,
      flip: g.default.bool,
      gameHistory: g.default.bool,
      getFensFromPgn: g.default.func,
      getHeader: g.default.func,
      getMovetext: g.default.func,
      getResult: g.default.func,
      getRows: g.default.func,
      height: g.default.oneOfType([g.default.string, g.default.number]),
      lightSquareColor: g.default.string,
      newlineChar: g.default.string,
      onMovePiece: g.default.func,
      onSelectSquare: g.default.func,
      pgn: g.default.string,
      pgnHeight: g.default.number,
      pieces: g.default.array,
      pieceDefinitions: g.default.object,
      ranks: g.default.number,
      squareSize: g.default.number,
      startMove: g.default.oneOfType([g.default.string, g.default.number]),
      startPosition: g.default.string,
      width: g.default.oneOfType([g.default.string, g.default.number])
    };

    var y = function y(e) {
      var t = r(6);
      t.Chess && (t = t.Chess);
      var n = new t();
      if (!e) return [n.fen()];
      n.load_pgn(e);

      for (var a = [n.fen()];;) {
        if (!n.undo()) break;
        a.push(n.fen());
      }

      return a = a.reverse();
    };

    v.defaultProps = {
      allowMoves: !0,
      darkSquareColor: "#005EBB",
      height: "auto",
      files: 8,
      flip: !1,
      gameHistory: !1,
      getFensFromPgn: y,
      lightSquareColor: "#2492FF",
      newlineChar: "\r?\n",
      pieceDefinitions: {},
      pgnHeight: 400,
      ranks: 8,
      startMove: 0,
      squareSize: 45,
      width: "auto"
    }, t.default = v;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function () {
      function e(e, t) {
        var r = [],
            n = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, s = e[Symbol.iterator](); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            !n && s.return && s.return();
          } finally {
            if (a) throw o;
          }
        }

        return r;
      }

      return function (t, r) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return e(t, r);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }(),
        l = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        u = r(0),
        p = n(u),
        f = r(10),
        c = n(f),
        d = r(11),
        h = n(d),
        m = r(12),
        g = n(m),
        v = r(1),
        y = n(v),
        b = function (e) {
      function t(e) {
        a(this, t);
        var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return r.state = {
          selectedSquare: null,
          selectedPieceType: null,
          dragX: 0,
          dragY: 0,
          isDragging: !1,
          left: 0,
          top: 0,
          width: 0,
          height: 0
        }, r._onResize = r._onResize.bind(r), r._onScroll = r._onScroll.bind(r), r;
      }

      return i(t, e), l(t, [{
        key: "componentDidMount",
        value: function value() {
          this._getClientPos(), addEventListener("resize", this._onResize), addEventListener("scroll", this._onScroll);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          removeEventListener("resize", this._onResize), removeEventListener("scroll", this._onScroll);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          if (e.squareSize !== this.props.squareSize || e.ranks !== this.props.ranks || e.files !== this.props.files) {
            var t = new Event("resize");
            dispatchEvent(t);
          }
        }
      }, {
        key: "_onResize",
        value: function value() {
          this._getClientPos();
        }
      }, {
        key: "_onScroll",
        value: function value() {
          this._getClientPos();
        }
      }, {
        key: "_onMouseDown",
        value: function value(e) {
          e.preventDefault();
          var t = e.clientX - this.state.left,
              r = e.clientY - this.state.top;

          this._grab(t, r);
        }
      }, {
        key: "_onTouchStart",
        value: function value(e) {
          e.preventDefault();
          var t = e.touches[0].clientX - this.state.left,
              r = e.touches[0].clientY - this.state.top;

          this._grab(t, r);
        }
      }, {
        key: "_onMouseMove",
        value: function value(e) {
          e.preventDefault();
          var t = e.clientX - this.state.left,
              r = e.clientY - this.state.top;

          this._move(t, r);
        }
      }, {
        key: "_onTouchMove",
        value: function value(e) {
          e.preventDefault();
          var t = e.touches[0].clientX - this.state.left,
              r = e.touches[0].clientY - this.state.top;

          this._move(t, r);
        }
      }, {
        key: "_onMouseUp",
        value: function value(e) {
          e.preventDefault();
          var t = e.clientX - this.state.left,
              r = e.clientY - this.state.top;

          this._release(t, r);
        }
      }, {
        key: "_onTouchEnd",
        value: function value(e) {
          e.preventDefault();
          var t = [this.state.dragX, this.state.dragY],
              r = t[0],
              n = t[1];

          this._release(r, n);
        }
      }, {
        key: "_squareToCoords",
        value: function value(e) {
          if (this.props.flip) {
            return [this.props.squareSize * (this.props.files - (e.toLowerCase().charCodeAt(0) - 97)), (Number(e.slice(1)) - 1) * this.props.squareSize];
          }

          return [this.props.squareSize * (1 + e.toLowerCase().charCodeAt(0) - 97), (this.props.ranks - Number(e.slice(1))) * this.props.squareSize];
        }
      }, {
        key: "_fileRankToCoords",
        value: function value(e, t) {
          if (this.props.flip) {
            return [this.props.squareSize * (this.props.files - e), this.props.squareSize * t];
          }

          return [this.props.squareSize * (1 + e), this.props.squareSize * (this.props.ranks - t - 1)];
        }
      }, {
        key: "_coordsToSquare",
        value: function value(e, t) {
          if (this.props.flip) {
            return String.fromCharCode(97 + this.props.files - e / this.props.squareSize + 1) + (1 + Math.floor(t / this.props.squareSize));
          }

          return String.fromCharCode(97 + e / this.props.squareSize - 1) + (1 + Math.floor((this.props.ranks * this.props.squareSize - t) / this.props.squareSize));
        }
      }, {
        key: "_grab",
        value: function value(e, t) {
          var r = this.props.squareSize * (1 + this.props.files),
              n = this.props.squareSize * this.props.ranks;
          if (e < this.props.squareSize || e > r || t < 0 || t > n) return !1;

          var a = this._coordsToSquare(e, t),
              o = this._getPieceAtSquare(a);

          this.state.selectedSquare && this.state.selectedSquare !== a || this.setState({
            selectedSquare: a,
            selectedPieceType: o ? o.pieceType : null,
            dragX: o ? o.x + this.props.squareSize / 2 : this.state.dragX,
            dragY: o ? o.y + this.props.squareSize / 2 : this.state.dragY,
            isDragging: !0
          }), this.props.onSelectSquare && this.props.onSelectSquare(a);
        }
      }, {
        key: "_move",
        value: function value(e, t) {
          this.state.isDragging && this.setState({
            dragX: e,
            dragY: t
          });
        }
      }, {
        key: "_release",
        value: function value(e, t) {
          this.setState({
            isDragging: !1
          });

          var r = this._coordsToSquare(e, t);

          r !== this.state.selectedSquare && (this.props.onMovePiece && this.props.onMovePiece(this.state.selectedPieceType, this.state.selectedSquare, r), this.setState({
            selectedSquare: null
          }));
        }
      }, {
        key: "_getClientPos",
        value: function value() {
          var e = this.Client.getBoundingClientRect();
          this.setState({
            left: e.left,
            top: e.top,
            width: e.width,
            height: e.height
          });
        }
      }, {
        key: "_getPieces",
        value: function value() {
          var e = this;
          return this.props.pieces ? this.props.pieces.map(function (t) {
            var r = t.split("@", 2),
                n = s(r, 2),
                a = n[0],
                o = n[1];
            if (!o) return {
              pieceType: "invalid",
              square: "none",
              x: 0,
              y: 0
            };

            var i = e._squareToCoords(o),
                l = s(i, 2),
                u = l[0],
                p = l[1];

            return isNaN(p) ? {
              pieceType: "invalid",
              square: "none",
              x: 0,
              y: 0
            } : {
              pieceType: a,
              square: o.toLowerCase(),
              x: u,
              y: p
            };
          }) : [];
        }
      }, {
        key: "_getPiecesFromFEN",
        value: function value() {
          var e = this,
              t = this.props.fen.split(" ", 6),
              r = Object.assign(g.default, this.props.pieceDefinitions),
              n = new RegExp("[" + Object.keys(r).join("").replace("-", "\\-") + "]");
          return t[0].replace(/(\d+|\w|\/)(?!$)/g, "$1,").split(",").reduce(function (t, r) {
            if (n.test(r)) {
              var a = e._fileRankToCoords(t.file, t.rank),
                  o = s(a, 2),
                  i = o[0],
                  l = o[1],
                  u = String.fromCharCode(97 + t.file) + (t.rank + 1).toString();

              t.pieces.push({
                pieceType: r,
                square: u,
                x: i,
                y: l
              }), t.file++;
            } else "/" === r ? (t.rank -= 1, t.file = 0) : Number.isInteger(parseInt(r)) && (t.file += Number(r));

            return t;
          }, {
            rank: this.props.ranks - 1,
            file: 0,
            pieces: []
          }).pieces;
        }
      }, {
        key: "_getPieceAtSquare",
        value: function value(e) {
          return (this.props.fen ? this._getPiecesFromFEN() : this._getPieces()).filter(function (t) {
            return t.square === e;
          })[0];
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props.fen ? this._getPiecesFromFEN() : this._getPieces(),
              r = Object.assign(g.default, this.props.pieceDefinitions),
              n = {};
          return this.state.selectedSquare && (n[this.state.selectedSquare] = "yellow"), p.default.createElement("svg", {
            ref: function ref(t) {
              e.Client = t;
            },
            style: {
              display: "inline-block"
            },
            height: "auto" === this.props.height ? (1 + this.props.ranks) * this.props.squareSize : this.props.height,
            onMouseDown: this._onMouseDown.bind(this),
            onMouseMove: this._onMouseMove.bind(this),
            onTouchEnd: this._onTouchEnd.bind(this),
            onTouchMove: this._onTouchMove.bind(this),
            onTouchStart: this._onTouchStart.bind(this),
            onMouseUp: this._onMouseUp.bind(this),
            width: "auto" === this.props.width ? (1 + this.props.files) * this.props.squareSize : this.props.width
          }, p.default.createElement(c.default, {
            darkSquareColor: this.props.darkSquareColor,
            files: this.props.files,
            flip: !!this.props.flip,
            highlights: n,
            lightSquareColor: this.props.lightSquareColor,
            ranks: this.props.ranks,
            selectedSquare: this.state.selectedSquare,
            squareSize: this.props.squareSize
          }), t.map(function (t, n) {
            return p.default.createElement(h.default, {
              x: e.state.isDragging && t.square === e.state.selectedSquare ? e.state.dragX - e.props.squareSize / 2 : t.x,
              y: e.state.isDragging && t.square === e.state.selectedSquare ? e.state.dragY - e.props.squareSize / 2 : t.y,
              key: n,
              pieceType: t.pieceType,
              squareSize: e.props.squareSize,
              drawPiece: r[t.pieceType]
            });
          }));
        }
      }]), t;
    }(u.Component);

    b.propTypes = {
      allowedMoves: y.default.object,
      darkSquareColor: y.default.string,
      fen: y.default.string,
      files: y.default.number,
      flip: y.default.bool,
      height: y.default.oneOfType([y.default.string, y.default.number]),
      lightSquareColor: y.default.string,
      onMovePiece: y.default.func,
      onSelectSquare: y.default.func,
      pieces: y.default.array,
      pieceDefinitions: y.default.object,
      ranks: y.default.number,
      squareSize: y.default.number,
      width: y.default.oneOfType([y.default.string, y.default.number])
    }, b.defaultProps = {
      allowedMoves: {},
      darkSquareColor: "#005EBB",
      height: "auto",
      files: 8,
      flip: !1,
      lightSquareColor: "#2492FF",
      pieceDefinitions: {},
      ranks: 8,
      squareSize: 45,
      width: "auto"
    }, t.default = b;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        l = r(0),
        u = n(l),
        p = r(18),
        f = n(p);

    r(22);

    var c = r(1),
        d = n(c),
        h = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), s(t, [{
        key: "shouldComponentUpdate",
        value: function value(e) {
          return this.props.rows.length !== e.rows.length || this.props.halfMove !== e.halfMove;
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this._scrollToActiveMove();
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          this._scrollToActiveMove();
        }
      }, {
        key: "_scrollToActiveMove",
        value: function value() {
          this.activeMove ? this.pgnContainer.scrollTop = this.activeMove.offsetTop : this.pgnContainer.scrollTop = 0;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = function t(_t) {
            return function (r) {
              var n = r.value,
                  a = r.row,
                  o = 2 * (a[0] - 1) + _t,
                  i = o === e.props.halfMove ? "yellow" : "#FFF";
              return u.default.createElement("span", {
                className: "pgn-cell",
                onClick: function onClick() {
                  return e.props.moveHead(o);
                },
                ref: function ref(t) {
                  o === e.props.halfMove && (e.activeMove = t);
                },
                style: {
                  backgroundColor: i
                }
              }, n);
            };
          },
              r = {
            sortable: !1
          },
              n = [{
            accessor: "0",
            id: "move",
            width: 40
          }, {
            accessor: "1",
            id: "white",
            width: 90,
            render: t(1)
          }, {
            accessor: "2",
            id: "black",
            width: 90,
            render: t(2)
          }].map(function (e) {
            return Object.assign({}, r, e);
          });

          return u.default.createElement("div", {
            ref: function ref(t) {
              e.pgnContainer = t;
            },
            style: {
              height: 200,
              overflowY: "scroll"
            }
          }, u.default.createElement(f.default, {
            data: this.props.rows,
            columns: n,
            showPagination: !1,
            pageSize: this.props.rows.length
          }));
        }
      }]), t;
    }(l.Component);

    h.propTypes = {
      rows: d.default.array,
      halfMove: d.default.number,
      moveHead: d.default.func
    };

    var m = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), s(t, [{
        key: "render",
        value: function value() {
          return u.default.createElement("div", null, u.default.createElement("button", {
            value: -1 / 0,
            onClick: this.props.moveHead
          }, "|<"), u.default.createElement("button", {
            value: -1,
            onClick: this.props.moveHead
          }, "<"), u.default.createElement("button", {
            value: 1,
            onClick: this.props.moveHead
          }, ">"), u.default.createElement("button", {
            value: 1 / 0,
            onClick: this.props.moveHead
          }, ">|"));
        }
      }]), t;
    }(l.Component);

    m.propTypes = {
      moveHead: d.default.func.isRequired
    };

    var g = function (e) {
      function t(e) {
        a(this, t);
        var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
            n = e.getMovetext(e.pgn, e.newlineChar),
            i = e.getRows(n, e.newlineChar),
            s = e.pgn ? 2 * (i.length - 1) + (i[i.length - 1].length - 1) : 0;
        return r.state = {
          header: e.getHeader(e.pgn, e.newlineChar),
          movetext: n,
          maxMove: s,
          rows: i
        }, r;
      }

      return i(t, e), s(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          if (e.pgn !== this.props.pgn) {
            var t = e.getMovetext(e.pgn, e.newlineChar),
                r = e.getRows(t, e.newlineChar),
                n = e.pgn ? 2 * (r.length - 1) + (r[r.length - 1].length - 1) : 0;
            this.setState({
              header: e.getHeader(e.pgn, e.newlineChar),
              maxMove: n,
              movetext: t,
              rows: r
            });
          }
        }
      }, {
        key: "_onMovePgnHead",
        value: function value(e) {
          var t = Number(e.target.value),
              r = this.props.currentMove,
              n = t > 0 ? 1 : -1,
              a = void 0;
          a = 1 === n ? Math.min(r + t, this.state.maxMove) : Math.max(r + t, 0), this.props.moveHead(a);
        }
      }, {
        key: "render",
        value: function value() {
          return u.default.createElement("div", {
            style: {
              display: "inline-block",
              position: "absolute",
              marginLeft: 5
            }
          }, u.default.createElement(h, {
            halfMove: this.props.currentMove,
            moveHead: this.props.moveHead,
            pgnHeight: this.props.pgnHeight,
            pgnWidth: this.props.pgnWidth,
            rows: this.props.getRows(this.props.getMovetext(this.props.pgn, this.props.newlineChar), this.props.newlineChar)
          }), u.default.createElement(m, {
            moveHead: this._onMovePgnHead.bind(this)
          }));
        }
      }]), t;
    }(l.Component);

    g.propTypes = {
      currentMove: d.default.number,
      getHeader: d.default.func,
      getMovetext: d.default.func,
      getResult: d.default.func,
      getRows: d.default.func,
      moveHead: d.default.func,
      newlineChar: d.default.string.isRequired,
      pgn: d.default.string,
      pgnHeight: d.default.number,
      pgnWidth: d.default.number,
      sloppy: d.default.bool
    };

    var v = function v(e, t) {
      var r = new RegExp("^(" + t + "|.)*(?:" + t + "){2}"),
          n = r.exec(e);
      return n ? n[0] : "";
    },
        y = function y(e, t) {
      var r = new RegExp("(?:" + t + "){2}(" + t + "|.)*$"),
          n = r.exec(e);
      return n ? n[0] : "";
    },
        b = function b(e, t) {
      var r = e;
      if (!r) return [];
      r = r.replace(/(\{[^}]+\})+?/g, "");

      for (var n = /(\([^\(\)]+\))+?/g; n.test(r);) {
        r = r.replace(n, "");
      }

      r = r.replace(/\$\d+/g, ""), r = r.replace(/(?:1-0|0-1|1\/2-1\/2|\*)$/, ""), r = r.replace(/\s\s/g, " ").trim();

      for (var a = [], o = /\d+\.\s?\S+(?:\s+\S+)?/g;;) {
        var i = o.exec(r);
        if (!i) break;
        var s = i[0].split(/\s|\.\s?/g);
        s[0] = parseInt(s[0]), a.push(s);
      }

      return a;
    },
        C = function C(e, t) {
      var r = new RegExp(/(?:1-0|0-1|1\/2-1\/2|\*)$/);
      return e.match(r)[0];
    };

    g.defaultProps = {
      getHeader: v,
      getMovetext: y,
      getResult: C,
      getRows: b,
      newlineChar: "\r?\n",
      sloppy: !1
    }, t.default = g;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function () {
      function e(e, t) {
        var r = [],
            n = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, s = e[Symbol.iterator](); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            !n && s.return && s.return();
          } finally {
            if (a) throw o;
          }
        }

        return r;
      }

      return function (t, r) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return e(t, r);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }(),
        l = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        u = r(0),
        p = n(u),
        f = r(1),
        c = n(f),
        d = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), l(t, [{
        key: "render",
        value: function value() {
          var e = this.props.light ? this.props.lightSquareColor : this.props.darkSquareColor;
          return p.default.createElement("rect", {
            fill: e,
            height: this.props.squareSize,
            stroke: "black",
            strokeWidth: "1",
            width: this.props.squareSize,
            x: this.props.x,
            y: this.props.y
          });
        }
      }]), t;
    }(u.Component);

    d.propTypes = {
      darkSquareColor: c.default.string.isRequired,
      light: c.default.bool.isRequired,
      lightSquareColor: c.default.string.isRequired,
      squareSize: c.default.number.isRequired,
      x: c.default.number.isRequired,
      y: c.default.number.isRequired
    }, d.displayName = "Square";

    var h = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), l(t, [{
        key: "render",
        value: function value() {
          return p.default.createElement("rect", {
            x: this.props.x,
            y: this.props.y,
            width: this.props.squareSize,
            height: this.props.squareSize,
            stroke: this.props.highlightColor,
            fill: "none",
            strokeWidth: "3"
          });
        }
      }]), t;
    }(u.Component);

    h.propTypes = {
      highlightColor: c.default.string.isRequired,
      squareSize: c.default.number.isRequired,
      x: c.default.number.isRequired,
      y: c.default.number.isRequired
    }, h.defaultProps = {
      highlightColor: "yellow"
    };

    var m = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), l(t, [{
        key: "_fileRankToCoords",
        value: function value(e, t) {
          if (this.props.flip) {
            return [this.props.squareSize * (this.props.files - e), this.props.squareSize * t];
          }

          return [this.props.squareSize * (1 + e), this.props.squareSize * (this.props.ranks - t - 1)];
        }
      }, {
        key: "render",
        value: function value() {
          for (var e = this, t = [], r = 0; r < this.props.ranks; r++) {
            var n = this.props.flip ? r : this.props.ranks - r - 1;
            t.push({
              y: this.props.squareSize / 2 + n * this.props.squareSize,
              label: r + 1
            });
          }

          return p.default.createElement("g", null, t.map(function (t, r) {
            return p.default.createElement("text", {
              x: e.props.squareSize / 2,
              y: t.y,
              key: r,
              fontFamily: "Verdana",
              fontSize: e.props.squareSize / 3,
              textAnchor: "middle"
            }, t.label);
          }));
        }
      }]), t;
    }(u.Component),
        g = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), l(t, [{
        key: "render",
        value: function value() {
          for (var e = this, t = [], r = 0; r < this.props.files; r++) {
            var n = this.props.flip ? this.props.files - r : 1 + r;
            t.push({
              x: this.props.squareSize / 2 + n * this.props.squareSize,
              label: String.fromCharCode(97 + r)
            });
          }

          return p.default.createElement("g", null, t.map(function (t, r) {
            return p.default.createElement("text", {
              x: t.x,
              y: e.props.squareSize / 2 + e.props.ranks * e.props.squareSize,
              key: r,
              fontFamily: "Verdana",
              fontSize: e.props.squareSize / 3,
              textAnchor: "middle"
            }, t.label);
          }));
        }
      }]), t;
    }(u.Component),
        v = {
      files: c.default.number,
      flip: c.default.bool.isRequired,
      ranks: c.default.number,
      squareSize: c.default.number.isRequired
    };

    m.propTypes = v, g.propTypes = v;

    var y = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), l(t, [{
        key: "_squareToCoords",
        value: function value(e) {
          if (this.props.flip) {
            return [this.props.squareSize * (this.props.files - (e.toLowerCase().charCodeAt(0) - 97)), (Number(e.slice(1)) - 1) * this.props.squareSize];
          }

          return [this.props.squareSize * (1 + e.toLowerCase().charCodeAt(0) - 97), (this.props.ranks - Number(e.slice(1))) * this.props.squareSize];
        }
      }, {
        key: "_fileRankToCoords",
        value: function value(e, t) {
          if (this.props.flip) {
            return [this.props.squareSize * (this.props.files - e), this.props.squareSize * t];
          }

          return [this.props.squareSize * (1 + e), this.props.squareSize * (this.props.ranks - t - 1)];
        }
      }, {
        key: "_indexToSquare",
        value: function value(e) {
          return "abcdefghijklmno"[Math.floor(e / this.props.files)] + (e % this.props.files + 1);
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value(e) {
          return e.selectedSquare !== this.props.selectedSquare || e.flip !== this.props.flip || e.squareSize !== this.props.squareSize || e.lightSquareColor !== this.props.lightSquareColor || e.darkSquareColor !== this.props.darkSquareColor || e.ranks !== this.props.ranks || e.files !== this.props.files;
        }
      }, {
        key: "render",
        value: function value() {
          for (var e = this, t = [], r = 0; r < this.props.files; r++) {
            for (var n = 0; n < this.props.ranks; n++) {
              var a = this._fileRankToCoords(r, n),
                  o = s(a, 2),
                  i = o[0],
                  l = o[1];

              t.push({
                x: i,
                y: l,
                light: 1 & (r ^ n)
              });
            }
          }

          return p.default.createElement("svg", null, t.map(function (t, r) {
            return p.default.createElement(d, {
              id: e._indexToSquare(r),
              square: e._indexToSquare(r),
              x: t.x,
              y: t.y,
              key: r,
              light: !!t.light,
              squareSize: e.props.squareSize,
              lightSquareColor: e.props.lightSquareColor,
              darkSquareColor: e.props.darkSquareColor
            });
          }), p.default.createElement(m, {
            ranks: this.props.ranks,
            files: this.props.files,
            squareSize: this.props.squareSize,
            flip: this.props.flip
          }), p.default.createElement(g, {
            ranks: this.props.ranks,
            files: this.props.files,
            squareSize: this.props.squareSize,
            flip: this.props.flip
          }), Object.keys(this.props.highlights).map(function (t) {
            var r = e._squareToCoords(t),
                n = s(r, 2),
                a = n[0],
                o = n[1];

            return p.default.createElement(h, {
              key: t,
              highlightColor: e.props.highlights[t],
              squareSize: e.props.squareSize,
              x: a,
              y: o
            });
          }));
        }
      }]), t;
    }(u.Component);

    y.propTypes = {
      darkSquareColor: c.default.string.isRequired,
      files: c.default.number.isRequired,
      flip: c.default.bool.isRequired,
      highlights: c.default.object,
      lightSquareColor: c.default.string.isRequired,
      ranks: c.default.number.isRequired,
      selectedSquare: c.default.string,
      squareSize: c.default.number.isRequired
    }, y.defaultProps = {
      darkSquareColor: "#005EBB",
      files: 8,
      flip: !1,
      highlights: {},
      lightSquareColor: "#2492FF",
      ranks: 8,
      squareSize: 45
    }, t.default = y;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        l = r(0);

    n(l);
    r(23);

    var u = r(1),
        p = n(u),
        f = function (e) {
      function t() {
        return a(this, t), o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return i(t, e), s(t, [{
        key: "shouldComponentUpdate",
        value: function value(e) {
          return e.x !== this.props.x || e.y !== this.props.y || e.pieceType !== this.props.pieceType || e.squareSize !== this.props.squareSize;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props.squareSize / 45,
              t = "translate(" + this.props.x + "," + this.props.y + ") scale(" + e + ")";
          return this.props.drawPiece(t);
        }
      }]), t;
    }(l.Component);

    f.propTypes = {
      drawPiece: p.default.func.isRequired,
      pieceType: p.default.string.isRequired,
      squareSize: p.default.number.isRequired,
      x: p.default.number.isRequired,
      y: p.default.number.isRequired
    }, t.default = f;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(0),
        a = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n),
        o = {
      K: function K(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_0",
          transform: e
        }, a.default.createElement("path", {
          d: "M 22.5,11.63 L 22.5,6",
          className: "path_0"
        }), a.default.createElement("path", {
          d: "M 20,8 L 25,8",
          className: "path_1"
        }), a.default.createElement("path", {
          d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
          className: "path_2"
        }), a.default.createElement("path", {
          d: "M 11.5,37 C 17,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 19,16 9.5,13 6.5,19.5 C 3.5,25.5 11.5,29.5 11.5,29.5 L 11.5,37 z ",
          className: "path_3"
        }), a.default.createElement("path", {
          d: "M 11.5,30 C 17,27 27,27 32.5,30",
          className: "path_4"
        }), a.default.createElement("path", {
          d: "M 11.5,33.5 C 17,30.5 27,30.5 32.5,33.5",
          className: "path_5"
        }), a.default.createElement("path", {
          d: "M 11.5,37 C 17,34 27,34 32.5,37",
          className: "path_6"
        })));
      },
      Q: function Q(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_1",
          transform: e
        }, a.default.createElement("path", {
          d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
          transform: "translate(-1,-1)"
        }), a.default.createElement("path", {
          d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
          transform: "translate(15.5,-5.5)"
        }), a.default.createElement("path", {
          d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
          transform: "translate(32,-1)"
        }), a.default.createElement("path", {
          d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
          transform: "translate(7,-4.5)"
        }), a.default.createElement("path", {
          d: "M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z",
          transform: "translate(24,-4)"
        }), a.default.createElement("path", {
          d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38,14 L 31,25 L 31,11 L 25.5,24.5 L 22.5,9.5 L 19.5,24.5 L 14,10.5 L 14,25 L 7,14 L 9,26 z ",
          className: "path_7"
        }), a.default.createElement("path", {
          d: "M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 10.5,36 10.5,36 C 9,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z ",
          className: "path_8"
        }), a.default.createElement("path", {
          d: "M 11.5,30 C 15,29 30,29 33.5,30",
          className: "path_9"
        }), a.default.createElement("path", {
          d: "M 12,33.5 C 18,32.5 27,32.5 33,33.5",
          className: "path_10"
        })));
      },
      R: function R(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_5",
          transform: e
        }, a.default.createElement("path", {
          d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
          className: "path_16"
        }), a.default.createElement("path", {
          d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
          className: "path_17"
        }), a.default.createElement("path", {
          d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14",
          className: "path_18"
        }), a.default.createElement("path", {
          d: "M 34,14 L 31,17 L 14,17 L 11,14"
        }), a.default.createElement("path", {
          d: "M 31,17 L 31,29.5 L 14,29.5 L 14,17",
          className: "path_19"
        }), a.default.createElement("path", {
          d: "M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5"
        }), a.default.createElement("path", {
          d: "M 11,14 L 34,14",
          className: "path_20"
        })));
      },
      B: function B(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_2",
          transform: e
        }, a.default.createElement("g", {
          className: "g_3"
        }, a.default.createElement("path", {
          d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.646,38.99 6.677,38.97 6,38 C 7.354,36.06 9,36 9,36 z"
        }), a.default.createElement("path", {
          d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
        }), a.default.createElement("path", {
          d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
        })), a.default.createElement("path", {
          d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
          className: "path_11"
        })));
      },
      N: function N(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_4",
          transform: e
        }, a.default.createElement("path", {
          d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
          className: "path_12"
        }), a.default.createElement("path", {
          d: "M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10",
          className: "path_13"
        }), a.default.createElement("path", {
          d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
          className: "path_14"
        }), a.default.createElement("path", {
          d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
          transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
          className: "path_15"
        })));
      },
      P: function P(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          transform: e
        }, a.default.createElement("path", {
          d: "M 22,9 C 19.79,9 18,10.79 18,13 C 18,13.89 18.29,14.71 18.78,15.38 C 16.83,16.5 15.5,18.59 15.5,21 C 15.5,23.03 16.44,24.84 17.91,26.03 C 14.91,27.09 10.5,31.58 10.5,39.5 L 33.5,39.5 C 33.5,31.58 29.09,27.09 26.09,26.03 C 27.56,24.84 28.5,23.03 28.5,21 C 28.5,18.59 27.17,16.5 25.22,15.38 C 25.71,14.71 26,13.89 26,13 C 26,10.79 24.21,9 22,9 z ",
          className: "path_21"
        })));
      },
      k: function k(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_6",
          transform: e
        }, a.default.createElement("path", {
          d: "M 22.5,11.63 L 22.5,6",
          className: "path_22"
        }), a.default.createElement("path", {
          d: "M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25",
          className: "path_23"
        }), a.default.createElement("path", {
          d: "M 11.5,37 C 17,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 19,16 9.5,13 6.5,19.5 C 3.5,25.5 11.5,29.5 11.5,29.5 L 11.5,37 z ",
          className: "path_24"
        }), a.default.createElement("path", {
          d: "M 20,8 L 25,8",
          className: "path_25"
        }), a.default.createElement("path", {
          d: "M 32,29.5 C 32,29.5 40.5,25.5 38.03,19.85 C 34.15,14 25,18 22.5,24.5 L 22.51,26.6 L 22.5,24.5 C 20,18 9.906,14 6.997,19.85 C 4.5,25.5 11.85,28.85 11.85,28.85",
          className: "path_26"
        }), a.default.createElement("path", {
          d: "M 11.5,30 C 17,27 27,27 32.5,30 M 11.5,33.5 C 17,30.5 27,30.5 32.5,33.5 M 11.5,37 C 17,34 27,34 32.5,37",
          className: "path_27"
        })));
      },
      q: function q(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_7",
          transform: e
        }, a.default.createElement("g", {
          className: "g_8"
        }, a.default.createElement("circle", {
          cx: "6",
          cy: "12",
          r: "2.75"
        }), a.default.createElement("circle", {
          cx: "14",
          cy: "9",
          r: "2.75"
        }), a.default.createElement("circle", {
          cx: "22.5",
          cy: "8",
          r: "2.75"
        }), a.default.createElement("circle", {
          cx: "31",
          cy: "9",
          r: "2.75"
        }), a.default.createElement("circle", {
          cx: "39",
          cy: "12",
          r: "2.75"
        })), a.default.createElement("path", {
          d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z",
          className: "path_28"
        }), a.default.createElement("path", {
          d: "M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 10.5,36 10.5,36 C 9,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z",
          className: "path_29"
        }), a.default.createElement("path", {
          d: "M 11,38.5 A 35,35 1 0 0 34,38.5",
          className: "path_30"
        }), a.default.createElement("path", {
          d: "M 10,28 A 20 10 1 0 1 35,28",
          className: "path_31"
        }), a.default.createElement("path", {
          d: "M 11.5,30.5 C 15,29 30,29 33.5,30.5",
          className: "path_33"
        }), a.default.createElement("path", {
          d: "M 12,33.5 C 18,32.5 27,32.5 33,33.5",
          className: "path_34"
        })));
      },
      r: function r(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_12",
          transform: e
        }, a.default.createElement("path", {
          d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z ",
          className: "path_41"
        }), a.default.createElement("path", {
          d: "M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z ",
          className: "path_42"
        }), a.default.createElement("path", {
          d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z ",
          className: "path_43"
        }), a.default.createElement("path", {
          d: "M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z ",
          className: "path_44"
        }), a.default.createElement("path", {
          d: "M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z ",
          className: "path_45"
        }), a.default.createElement("path", {
          d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z ",
          className: "path_46"
        }), a.default.createElement("path", {
          d: "M 12,35.5 L 33,35.5 L 33,35.5",
          className: "path_47"
        }), a.default.createElement("path", {
          d: "M 13,31.5 L 32,31.5",
          className: "path_48"
        }), a.default.createElement("path", {
          d: "M 14,29.5 L 31,29.5",
          className: "path_49"
        }), a.default.createElement("path", {
          d: "M 14,16.5 L 31,16.5",
          className: "path_50"
        }), a.default.createElement("path", {
          d: "M 11,14 L 34,14",
          className: "path_51"
        })));
      },
      b: function b(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_9",
          transform: e
        }, a.default.createElement("g", {
          className: "g_10"
        }, a.default.createElement("path", {
          d: "M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.646,38.99 6.677,38.97 6,38 C 7.354,36.06 9,36 9,36 z"
        }), a.default.createElement("path", {
          d: "M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z"
        }), a.default.createElement("path", {
          d: "M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z"
        })), a.default.createElement("path", {
          d: "M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18",
          className: "path_35"
        })));
      },
      n: function n(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          className: "g_11",
          transform: e
        }, a.default.createElement("path", {
          d: "M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18",
          className: "path_36"
        }), a.default.createElement("path", {
          d: "m 24,18 c 0.38,2.91 -5.55,7.37 -8,9 c -3,2 -2.82,4.34 -5,4 c -1.042,-0.94 2.508114,-2.95553 0.337881,-3.380116 c -2.170232,-0.424587 -1.45717,1.652351 -2.64717,2.422351 c -1,0 -2.693711,0.957765 -2.690711,-4.042235c0,-2 6,-12 6,-12 c 0,0 1.89,-1.9 2,-3.5 c -0.73,-0.994 -0.5,-2 -0.5,-3 c 1,-1 3,2.5 3,2.5 l2,0 c 0,0 0.78,-1.992 2.5,-3 c 1,0 1,3 1,3",
          className: "path_37"
        }), a.default.createElement("path", {
          d: "M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z",
          className: "path_38"
        }), a.default.createElement("path", {
          d: "M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z",
          transform: "matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)",
          className: "path_39"
        }), a.default.createElement("path", {
          d: "M 24.55,10.4 L 24.1,11.85 L 24.6,12 C 27.75,13 30.25,14.49 32.5,18.75 C 34.75,23.01 35.75,29.06 35.25,39 L 35.2,39.5 L 37.45,39.5 L 37.5,39 C 38,28.94 36.62,22.15 34.25,17.66 C 31.88,13.17 28.46,11.02 25.06,10.5 L 24.55,10.4 z ",
          className: "path_40"
        })));
      },
      p: function p(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          transform: e
        }, a.default.createElement("path", {
          d: "M 22,9 C 19.79,9 18,10.79 18,13 C 18,13.89 18.29,14.71 18.78,15.38 C 16.83,16.5 15.5,18.59 15.5,21 C 15.5,23.03 16.44,24.84 17.91,26.03 C 14.91,27.09 10.5,31.58 10.5,39.5 L 33.5,39.5 C 33.5,31.58 29.09,27.09 26.09,26.03 C 27.56,24.84 28.5,23.03 28.5,21 C 28.5,18.59 27.17,16.5 25.22,15.38 C 25.71,14.71 26,13.89 26,13 C 26,10.79 24.21,9 22,9 z ",
          className: "path_52"
        })));
      },
      "-": function _(e) {
        return a.default.createElement("svg", null, a.default.createElement("g", {
          transform: e
        }, a.default.createElement("rect", {
          x: "0",
          y: "0",
          width: 45,
          height: 45,
          fill: "black",
          fillOpacity: "0.8"
        })));
      }
    };

    t.default = o;
  }, function (e, t, r) {
    t = e.exports = r(4)(), t.push([e.i, '.ReactTable{position:relative;border:1px solid rgba(0,0,0,.1)}.ReactTable *{box-sizing:border-box}.ReactTable .rt-table{-ms-flex-align:stretch;align-items:stretch;width:100%;border-collapse:collapse;overflow:auto}.ReactTable .rt-table,.ReactTable .rt-thead{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.ReactTable .rt-thead{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ReactTable .rt-thead.-headerGroups{background:rgba(0,0,0,.03)}.ReactTable .rt-thead.-filters,.ReactTable .rt-thead.-headerGroups{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-thead.-filters .rt-th{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-thead.-header{box-shadow:0 2px 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-thead .rt-tr{text-align:center}.ReactTable .rt-thead .rt-td,.ReactTable .rt-thead .rt-th{padding:5px;line-height:normal;position:relative;border-right:1px solid rgba(0,0,0,.05);transition:box-shadow .3s cubic-bezier(.175,.885,.32,1.275);box-shadow:inset 0 0 0 0 transparent}.ReactTable .rt-thead .rt-td.-sort-asc,.ReactTable .rt-thead .rt-th.-sort-asc{box-shadow:inset 0 3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-sort-desc,.ReactTable .rt-thead .rt-th.-sort-desc{box-shadow:inset 0 -3px 0 0 rgba(0,0,0,.6)}.ReactTable .rt-thead .rt-td.-cursor-pointer,.ReactTable .rt-thead .rt-th.-cursor-pointer{cursor:pointer}.ReactTable .rt-thead .rt-td:last-child,.ReactTable .rt-thead .rt-th:last-child{border-right:0}.ReactTable .rt-thead .rt-resizable-header{overflow:visible}.ReactTable .rt-thead .rt-resizable-header:last-child{overflow:hidden}.ReactTable .rt-thead .rt-resizable-header-content{overflow:hidden;text-overflow:ellipsis}.ReactTable .rt-tbody{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.ReactTable .rt-tbody .rt-tr-group{border-bottom:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tbody .rt-tr-group:last-child{border-bottom:0}.ReactTable .rt-tbody .rt-td{border-right:1px solid rgba(0,0,0,.02)}.ReactTable .rt-tbody .rt-td:last-child{border-right:0}.ReactTable .rt-tbody .rt-pivot{cursor:pointer}.ReactTable .rt-tr-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch}.ReactTable .rt-tr{display:-ms-inline-flexbox;display:inline-flex}.ReactTable .rt-td,.ReactTable .rt-th{-ms-flex:1 0 0px;flex:1 0 0;white-space:nowrap;text-overflow:ellipsis;padding:7px 5px;overflow:hidden;transition:.3s ease;transition-property:width,min-width,padding,opacity}.ReactTable .rt-td.-hidden,.ReactTable .rt-th.-hidden{width:0!important;min-width:0!important;padding:0!important;border:0!important;opacity:0!important}.ReactTable .rt-expander{display:inline-block;position:relative;margin:0;color:transparent;margin:0 10px}.ReactTable .rt-expander:after{content:"";position:absolute;width:0;height:0;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-90deg);border-left:5.04px solid transparent;border-right:5.04px solid transparent;border-top:7px solid rgba(0,0,0,.8);transition:all .3s cubic-bezier(.175,.885,.32,1.275);cursor:pointer}.ReactTable .rt-expander.-open:after{transform:translate(-50%,-50%) rotate(0)}.ReactTable .rt-resizer{display:inline-block;position:absolute;width:36px;top:0;bottom:0;right:-18px;cursor:col-resize;z-index:10}.ReactTable .rt-tfoot{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;box-shadow:0 0 15px 0 rgba(0,0,0,.15)}.ReactTable .rt-tfoot .rt-td{border-right:1px solid rgba(0,0,0,.05)}.ReactTable .rt-tfoot .rt-td:last-child{border-right:0}.ReactTable.-striped .rt-tr.-odd{background:rgba(0,0,0,.03)}.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover{background:rgba(0,0,0,.05)}.ReactTable .-pagination{z-index:1;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:stretch;align-items:stretch;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:3px;box-shadow:0 0 15px 0 rgba(0,0,0,.1);border-top:2px solid rgba(0,0,0,.1)}.ReactTable .-pagination .-btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;width:100%;height:100%;border:0;border-radius:3px;padding:6px;font-size:1em;color:rgba(0,0,0,.6);background:rgba(0,0,0,.1);transition:all .1s ease;cursor:pointer;outline:none}.ReactTable .-pagination .-btn[disabled]{opacity:.5;cursor:default}.ReactTable .-pagination .-btn:not([disabled]):hover{background:rgba(0,0,0,.3);color:#fff}.ReactTable .-pagination .-next,.ReactTable .-pagination .-previous{-ms-flex:1;flex:1;text-align:center}.ReactTable .-pagination .-center{-ms-flex:1.5;flex:1.5;text-align:center;margin-bottom:0;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.ReactTable .-pagination .-pageInfo{display:inline-block;margin:3px 10px;white-space:nowrap}.ReactTable .-pagination .-pageJump{display:inline-block}.ReactTable .-pagination .-pageJump input{width:70px;text-align:center}.ReactTable .-pagination .-pageSizeOptions{margin:3px 10px}.ReactTable .rt-noData{left:50%;top:50%;transform:translate(-50%,-50%);z-index:1;padding:20px;color:rgba(0,0,0,.5)}.ReactTable .-loading,.ReactTable .rt-noData{display:block;position:absolute;background:hsla(0,0%,100%,.8);transition:all .3s ease;pointer-events:none}.ReactTable .-loading{left:0;right:0;top:0;bottom:0;z-index:2;opacity:0}.ReactTable .-loading>div{position:absolute;display:block;text-align:center;width:100%;top:50%;left:0;font-size:15px;color:rgba(0,0,0,.6);transform:translateY(-52%);transition:all .3s cubic-bezier(.25,.46,.45,.94)}.ReactTable .-loading.-active{opacity:1;pointer-events:all}.ReactTable .-loading.-active>div{transform:translateY(50%)}.ReactTable input,.ReactTable select{border:1px solid rgba(0,0,0,.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:400;outline:none}.ReactTable input:not([type=checkbox]):not([type=radio]),.ReactTable select{-webkit-appearance:none;-moz-appearance:none;appearance:none}.ReactTable .select-wrap{position:relative;display:inline-block}.ReactTable .select-wrap select{padding:5px 15px 5px 7px;min-width:100px}.ReactTable .select-wrap:after{content:"";position:absolute;right:8px;top:50%;transform:translateY(-50%);border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px}', ""]);
  }, function (e, t, r) {
    t = e.exports = r(4)(), t.push([e.i, ".g_0,.g_6{fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1}.g_1,.g_5{fill:#fff;fill-opacity:1;fill-rule:evenodd}.g_1,.g_2,.g_5,.g_9{opacity:1;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1}.g_2,.g_9{fill:none;fill-rule:evenodd;fill-opacity:1}.g_3{fill:#fff;stroke:#000;stroke-linecap:butt}.g_4{opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1}.g_10{fill:#000;stroke:#000;stroke-linecap:butt}.g_11{fill:none;fill-opacity:1;fill-rule:evenodd}.g_7,.g_11,.g_12{opacity:1;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1}.g_7,.g_12{fill:#000;fill-opacity:1;fill-rule:evenodd}.g_8{fill:#000;stroke:none}.path_0,.path_1,.path_11,.path_20,.path_22,.path_25{fill:none;stroke:#000;stroke-linejoin:miter}.path_2{fill:#fff;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter}.path_3,.path_12,.path_13{fill:#fff;stroke:#000}.path_13{stroke-width:1.4}.path_4,.path_5,.path_6{fill:none;stroke:#000}.path_7,.path_8,.path_16,.path_17,.path_18,.path_29,.path_41,.path_42,.path_43,.path_45,.path_46{stroke-linecap:butt}.path_9,.path_10{fill:none}.path_14,.path_15,.path_24,.path_36,.path_37{fill:#000;stroke:#000}.path_37{stroke-width:1.4}.path_19{stroke-linecap:butt;stroke-linejoin:miter}.path_21{opacity:1;fill:#fff;fill-opacity:1;fill-rule:nonzero;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1}.path_23{fill:#000;fill-opacity:1;stroke-linecap:butt;stroke-linejoin:miter}.path_26,.path_27,.path_31,.path_32,.path_33,.path_34{fill:none;stroke:#fff}.path_28,.path_30{stroke-linecap:butt;stroke:#000}.path_30,.path_35{fill:none}.path_35{stroke:#fff;stroke-linejoin:miter}.path_38,.path_39{fill:#fff;stroke:#fff}.path_40{fill:#fff;stroke:none}.path_44{stroke-linecap:butt;stroke-linejoin:miter}.path_47,.path_48,.path_49,.path_50,.path_51{fill:none;stroke:#fff;stroke-width:1;stroke-linejoin:miter}.path_52{opacity:1;fill:#000;fill-opacity:1;fill-rule:nonzero;stroke:#000;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1}", ""]);
  }, function (e, t, r) {
    "use strict";

    function n() {}

    var a = r(16);

    e.exports = function () {
      function e(e, t, r, n, o, i) {
        if (i !== a) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return r.checkPropTypes = n, r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      var r = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
      }

      return r;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        i = r(0),
        s = n(i),
        l = r(2),
        u = n(l),
        p = r(3),
        f = n(p),
        c = r(21),
        d = n(c),
        h = function h() {
      return {};
    };

    t.default = {
      data: [],
      loading: !1,
      showPagination: !0,
      showPageSizeOptions: !0,
      pageSizeOptions: [5, 10, 20, 25, 50, 100],
      defaultPageSize: 20,
      showPageJump: !0,
      collapseOnSortingChange: !0,
      collapseOnPageChange: !0,
      collapseOnDataChange: !0,
      freezeWhenExpanded: !1,
      defaultSorting: [],
      showFilters: !1,
      defaultFiltering: [],
      defaultFilterMethod: function defaultFilterMethod(e, t, r) {
        var n = e.pivotId || e.id;
        return void 0 === t[n] || String(t[n]).startsWith(e.value);
      },
      resizable: !0,
      defaultResizing: [],
      onExpandSubComponent: void 0,
      onPageChange: void 0,
      onPageSizeChange: void 0,
      onSortingChange: void 0,
      onFilteringChange: void 0,
      onResize: void 0,
      pivotBy: void 0,
      pivotColumnWidth: 200,
      pivotValKey: "_pivotVal",
      pivotIDKey: "_pivotID",
      subRowsKey: "_subRows",
      onExpandRow: void 0,
      onChange: function onChange() {
        return null;
      },
      className: "",
      style: {},
      getProps: h,
      getTableProps: h,
      getTheadGroupProps: h,
      getTheadGroupTrProps: h,
      getTheadGroupThProps: h,
      getTheadProps: h,
      getTheadTrProps: h,
      getTheadThProps: h,
      getTheadFilterProps: h,
      getTheadFilterTrProps: h,
      getTheadFilterThProps: h,
      getTbodyProps: h,
      getTrGroupProps: h,
      getTrProps: h,
      getTdProps: h,
      getTfootProps: h,
      getTfootTrProps: h,
      getTfootTdProps: h,
      getPaginationProps: h,
      getLoadingProps: h,
      getNoDataProps: h,
      getResizerProps: h,
      column: {
        sortable: !0,
        show: !0,
        minWidth: 100,
        render: void 0,
        className: "",
        style: {},
        getProps: h,
        header: void 0,
        headerClassName: "",
        headerStyle: {},
        getHeaderProps: h,
        footer: void 0,
        footerClassName: "",
        footerStyle: {},
        getFooterProps: h,
        filterMethod: void 0,
        hideFilter: !1,
        filterRender: function filterRender(e) {
          var t = e.filter,
              r = e.onFilterChange;
          return s.default.createElement("input", {
            type: "text",
            style: {
              width: "100%"
            },
            value: t ? t.value : "",
            onChange: function onChange(e) {
              return r(e.target.value);
            }
          });
        }
      },
      expanderDefaults: {
        sortable: !1,
        width: 35,
        hideFilter: !0
      },
      pivotDefaults: {},
      previousText: "Previous",
      nextText: "Next",
      loadingText: "Loading...",
      noDataText: "No rows found",
      pageText: "Page",
      ofText: "of",
      rowsText: "rows",
      TableComponent: f.default.makeTemplateComponent("rt-table"),
      TheadComponent: f.default.makeTemplateComponent("rt-thead"),
      TbodyComponent: f.default.makeTemplateComponent("rt-tbody"),
      TrGroupComponent: f.default.makeTemplateComponent("rt-tr-group"),
      TrComponent: f.default.makeTemplateComponent("rt-tr"),
      ThComponent: function ThComponent(e) {
        var t = e.toggleSort,
            r = e.className,
            n = e.children,
            i = a(e, ["toggleSort", "className", "children"]);
        return s.default.createElement("div", o({
          className: (0, u.default)(r, "rt-th"),
          onClick: function onClick(e) {
            t && t(e);
          }
        }, i), n);
      },
      TdComponent: f.default.makeTemplateComponent("rt-td"),
      TfootComponent: f.default.makeTemplateComponent("rt-tfoot"),
      ExpanderComponent: function ExpanderComponent(e) {
        var t = e.isExpanded;
        return s.default.createElement("div", {
          className: (0, u.default)("rt-expander", t && "-open")
        }, "•");
      },
      PaginationComponent: d.default,
      PreviousComponent: void 0,
      NextComponent: void 0,
      LoadingComponent: function LoadingComponent(e) {
        var t = e.className,
            r = e.loading,
            n = e.loadingText,
            i = a(e, ["className", "loading", "loadingText"]);
        return s.default.createElement("div", o({
          className: (0, u.default)("-loading", {
            "-active": r
          }, t)
        }, i), s.default.createElement("div", {
          className: "-loading-inner"
        }, n));
      },
      NoDataComponent: f.default.makeTemplateComponent("rt-noData"),
      ResizerComponent: f.default.makeTemplateComponent("rt-resizer")
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ReactTableDefaults = void 0;

    var s = function () {
      function e(e, t) {
        var r = [],
            n = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, s = e[Symbol.iterator](); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            !n && s.return && s.return();
          } finally {
            if (a) throw o;
          }
        }

        return r;
      }

      return function (t, r) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return e(t, r);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }(),
        l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        u = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        p = r(0),
        f = n(p),
        c = r(2),
        d = n(c),
        h = r(3),
        m = n(h),
        g = r(19),
        v = n(g),
        y = r(20),
        b = n(y),
        C = r(17),
        _ = n(C),
        w = (t.ReactTableDefaults = _.default, function (e) {
      function t(e) {
        a(this, t);
        var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
        return r.getResolvedState = r.getResolvedState.bind(r), r.getDataModel = r.getDataModel.bind(r), r.getSortedData = r.getSortedData.bind(r), r.fireOnChange = r.fireOnChange.bind(r), r.getPropOrState = r.getPropOrState.bind(r), r.getStateOrProp = r.getStateOrProp.bind(r), r.filterData = r.filterData.bind(r), r.sortData = r.sortData.bind(r), r.getMinRows = r.getMinRows.bind(r), r.onPageChange = r.onPageChange.bind(r), r.onPageSizeChange = r.onPageSizeChange.bind(r), r.sortColumn = r.sortColumn.bind(r), r.filterColumn = r.filterColumn.bind(r), r.resizeColumnStart = r.resizeColumnStart.bind(r), r.resizeColumnEnd = r.resizeColumnEnd.bind(r), r.resizeColumnMoving = r.resizeColumnMoving.bind(r), r.state = {
          page: 0,
          pageSize: e.defaultPageSize || 10,
          sorting: e.defaultSorting,
          expandedRows: {},
          filtering: e.defaultFiltering,
          resizing: e.defaultResizing,
          currentlyResizing: void 0,
          skipNextSort: !1
        }, r;
      }

      return i(t, e), u(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.getResolvedState(),
              r = t.children,
              n = t.className,
              a = t.style,
              o = t.getProps,
              i = t.getTableProps,
              u = t.getTheadGroupProps,
              p = t.getTheadGroupTrProps,
              c = t.getTheadGroupThProps,
              h = t.getTheadProps,
              g = t.getTheadTrProps,
              v = t.getTheadThProps,
              y = t.getTheadFilterProps,
              b = t.getTheadFilterTrProps,
              C = t.getTheadFilterThProps,
              w = t.getTbodyProps,
              x = t.getTrGroupProps,
              E = t.getTrProps,
              S = t.getTdProps,
              k = t.getTfootProps,
              P = t.getTfootTrProps,
              T = t.getTfootTdProps,
              R = t.getPaginationProps,
              O = t.getLoadingProps,
              z = t.getNoDataProps,
              N = t.getResizerProps,
              M = t.showPagination,
              q = t.manual,
              L = t.loadingText,
              j = t.noDataText,
              D = t.showFilters,
              A = t.resizable,
              F = t.loading,
              I = t.pageSize,
              W = t.page,
              U = t.sorting,
              K = t.filtering,
              H = t.resizing,
              B = t.pages,
              Q = t.pivotValKey,
              G = t.subRowsKey,
              $ = t.expandedRows,
              V = t.onExpandRow,
              X = t.TableComponent,
              Y = t.TheadComponent,
              J = t.TbodyComponent,
              Z = t.TrGroupComponent,
              ee = t.TrComponent,
              te = t.ThComponent,
              re = t.TdComponent,
              ne = t.TfootComponent,
              ae = t.PaginationComponent,
              oe = t.LoadingComponent,
              ie = t.SubComponent,
              se = t.NoDataComponent,
              le = t.ResizerComponent,
              ue = t.resolvedData,
              pe = t.allVisibleColumns,
              fe = t.headerGroups,
              ce = t.hasHeaderGroups,
              de = t.sortedData,
              he = I * W,
              me = he + I,
              ge = q ? ue : de.slice(he, me),
              ve = this.getMinRows(),
              ye = m.default.range(Math.max(ve - ge.length, 0)),
              be = pe.some(function (e) {
            return e.footer;
          }),
              Ce = function e(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1;
            return [t.map(function (t, a) {
              n++;
              var o = l({}, t, {
                _viewIndex: n
              }),
                  i = r.concat([a]);

              if (o[G] && m.default.get($, i)) {
                var u = e(o[G], i, n),
                    p = s(u, 2);
                o[G] = p[0], n = p[1];
              }

              return o;
            }), n];
          }(ge),
              _e = s(Ce, 1);

          ge = _e[0];

          var we = W > 0,
              xe = W + 1 < B,
              Ee = m.default.sum(pe.map(function (e) {
            var t = H.find(function (t) {
              return t.id === e.id;
            }) || {};
            return m.default.getFirstDefined(t.value, e.width, e.minWidth);
          })),
              Se = -1,
              ke = l({}, t, {
            startRow: he,
            endRow: me,
            pageRows: ge,
            minRows: ve,
            padRows: ye,
            hasColumnFooter: be,
            canPrevious: we,
            canNext: xe,
            rowMinWidth: Ee
          }),
              Pe = function Pe() {
            var t = m.default.splitProps(u(ke, void 0, void 0, e)),
                r = m.default.splitProps(p(ke, void 0, void 0, e));
            return f.default.createElement(Y, l({
              className: (0, d.default)("-headerGroups", t.className),
              style: l({}, t.style, {
                minWidth: Ee + "px"
              })
            }, t.rest), f.default.createElement(ee, l({
              className: r.className,
              style: r.style
            }, r.rest), fe.map(Te)));
          },
              Te = function Te(t, r) {
            var n = m.default.sum(t.columns.map(function (e) {
              var t = H.find(function (t) {
                return t.id === e.id;
              }) || {};
              return e.width || t.value ? 0 : e.minWidth;
            })),
                a = m.default.sum(t.columns.map(function (e) {
              var t = H.find(function (t) {
                return t.id === e.id;
              }) || {};
              return m.default.getFirstDefined(t.value, e.width, e.minWidth);
            })),
                o = m.default.sum(t.columns.map(function (e) {
              var t = H.find(function (t) {
                return t.id === e.id;
              }) || {};
              return m.default.getFirstDefined(t.value, e.width, e.maxWidth);
            })),
                i = m.default.splitProps(c(ke, void 0, t, e)),
                s = m.default.splitProps(t.getHeaderProps(ke, void 0, t, e)),
                u = [t.headerClassName, i.className, s.className],
                p = l({}, t.headerStyle, i.style, s.style),
                h = l({}, i.rest, s.rest),
                g = {
              flex: n + " 0 auto",
              width: a + "px",
              maxWidth: o + "px"
            };
            return f.default.createElement(te, l({
              key: r,
              className: (0, d.default)(u),
              style: l({}, p, g)
            }, h), m.default.normalizeComponent(t.header, {
              data: de,
              column: t
            }));
          },
              Re = function Re() {
            var t = m.default.splitProps(h(ke, void 0, void 0, e)),
                r = m.default.splitProps(g(ke, void 0, void 0, e));
            return f.default.createElement(Y, l({
              className: (0, d.default)("-header", t.className),
              style: l({}, t.style, {
                minWidth: Ee + "px"
              })
            }, t.rest), f.default.createElement(ee, l({
              className: r.className,
              style: r.style
            }, r.rest), pe.map(Oe)));
          },
              Oe = function Oe(t, r) {
            var n = H.find(function (e) {
              return e.id === t.id;
            }) || {},
                a = U.find(function (e) {
              return e.id === t.id;
            }),
                o = "function" == typeof t.show ? t.show() : t.show,
                i = m.default.getFirstDefined(n.value, t.width, t.minWidth),
                s = m.default.getFirstDefined(n.value, t.width, t.maxWidth),
                u = m.default.splitProps(v(ke, void 0, t, e)),
                p = m.default.splitProps(t.getHeaderProps(ke, void 0, t, e)),
                c = [t.headerClassName, u.className, p.className],
                h = l({}, t.headerStyle, u.style, p.style),
                g = l({}, u.rest, p.rest),
                y = A ? f.default.createElement(le, l({
              onMouseDown: function onMouseDown(r) {
                return e.resizeColumnStart(t, r, !1);
              },
              onTouchStart: function onTouchStart(r) {
                return e.resizeColumnStart(t, r, !0);
              }
            }, Ue)) : null;

            if (t.expander && t.pivotColumns) {
              var b = U.find(function (e) {
                return e.id === t.id;
              });
              return f.default.createElement(te, l({
                key: r,
                className: (0, d.default)("rt-pivot-header", "rt-resizable-header", t.sortable && "-cursor-pointer", c, b ? b.desc ? "-sort-desc" : "-sort-asc" : ""),
                style: l({}, h, {
                  flex: i + " 0 auto",
                  width: i + "px",
                  maxWidth: s + "px"
                }),
                toggleSort: function toggleSort(r) {
                  t.sortable && e.sortColumn(t.pivotColumns, r.shiftKey);
                }
              }, g), f.default.createElement("div", {
                className: "rt-resizable-header-content"
              }, t.pivotColumns.map(function (e, r) {
                return f.default.createElement("span", {
                  key: e.id
                }, m.default.normalizeComponent(e.header, {
                  data: de,
                  column: t
                }), r < t.pivotColumns.length - 1 && m.default.normalizeComponent(t.render, {
                  data: de,
                  column: t
                }));
              })), y);
            }

            return f.default.createElement(te, l({
              key: r,
              className: (0, d.default)(c, "rt-resizable-header", a ? a.desc ? "-sort-desc" : "-sort-asc" : "", t.sortable && "-cursor-pointer", !o && "-hidden"),
              style: l({}, h, {
                flex: i + " 0 auto",
                width: i + "px",
                maxWidth: s + "px"
              }),
              toggleSort: function toggleSort(r) {
                t.sortable && e.sortColumn(t, r.shiftKey);
              }
            }, g), f.default.createElement("div", {
              className: "rt-resizable-header-content"
            }, m.default.normalizeComponent(t.header, {
              data: de,
              column: t
            })), y);
          },
              ze = function ze() {
            var t = m.default.splitProps(y(ke, void 0, void 0, e)),
                r = m.default.splitProps(b(ke, void 0, void 0, e));
            return f.default.createElement(Y, l({
              className: (0, d.default)("-filters", t.className),
              style: l({}, t.style, {
                minWidth: Ee + "px"
              })
            }, t.rest), f.default.createElement(ee, l({
              className: r.className,
              style: r.style
            }, r.rest), pe.map(Ne)));
          },
              Ne = function Ne(t, r) {
            var n = H.find(function (e) {
              return e.id === t.id;
            }) || {},
                a = m.default.getFirstDefined(n.value, t.width, t.minWidth),
                o = m.default.getFirstDefined(n.value, t.width, t.maxWidth),
                i = m.default.splitProps(C(ke, void 0, t, e)),
                s = m.default.splitProps(t.getHeaderProps(ke, void 0, t, e)),
                u = [t.headerClassName, i.className, s.className],
                p = l({}, t.headerStyle, i.style, s.style),
                c = l({}, i.rest, s.rest);

            if (t.expander && t.pivotColumns) {
              for (var h = [], g = 0; g < t.pivotColumns.length; g++) {
                !function (r) {
                  var n = t.pivotColumns[r],
                      a = K.find(function (e) {
                    return e.id === t.id && e.pivotId === n.id;
                  });
                  h.push(f.default.createElement("span", {
                    key: n.id,
                    style: {
                      flex: 1
                    }
                  }, n.hideFilter ? null : m.default.normalizeComponent(n.filterRender, {
                    col: n,
                    filter: a,
                    onFilterChange: function onFilterChange(r) {
                      return e.filterColumn(t, r, n);
                    }
                  }, _.default.column.filterRender))), r < t.pivotColumns.length - 1 && h.push(m.default.normalizeComponent(t.filterRender, {
                    column: t,
                    filter: a,
                    key: n.id + "-" + r
                  }, _.default.column.filterRender));
                }(g);
              }

              return f.default.createElement(te, l({
                key: r,
                className: (0, d.default)("rt-pivot-header", t.sortable && "-cursor-pointer", u),
                style: l({}, p, {
                  flex: a + " 0 auto",
                  width: a + "px",
                  maxWidth: o + "px",
                  display: "flex"
                })
              }, c), h);
            }

            var v = K.find(function (e) {
              return e.id === t.id;
            });
            return f.default.createElement(te, l({
              key: r,
              className: (0, d.default)(u),
              style: l({}, p, {
                flex: a + " 0 auto",
                width: a + "px",
                maxWidth: o + "px"
              })
            }, c), t.hideFilter ? null : m.default.normalizeComponent(t.filterRender, {
              column: t,
              filter: v,
              onFilterChange: function onFilterChange(r) {
                return e.filterColumn(t, r);
              }
            }, _.default.column.filterRender));
          },
              Me = function t(r, n) {
            var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
                o = {
              row: r.__original,
              rowValues: r,
              index: r.__index,
              viewIndex: ++Se,
              level: a.length,
              nestingPath: a.concat([n]),
              aggregated: !!r[G],
              subRows: r[G]
            },
                i = m.default.get($, o.nestingPath),
                s = x(ke, o, void 0, e),
                u = m.default.splitProps(E(ke, o, void 0, e));
            return f.default.createElement(Z, l({
              key: o.nestingPath.join("_")
            }, s), f.default.createElement(ee, l({
              className: (0, d.default)(u.className, r._viewIndex % 2 ? "-even" : "-odd"),
              style: u.style
            }, u.rest), pe.map(function (t, n) {
              var a = H.find(function (e) {
                return e.id === t.id;
              }) || {},
                  s = "function" == typeof t.show ? t.show() : t.show,
                  u = m.default.getFirstDefined(a.value, t.width, t.minWidth),
                  p = m.default.getFirstDefined(a.value, t.width, t.maxWidth),
                  c = m.default.splitProps(S(ke, o, t, e)),
                  h = m.default.splitProps(t.getProps(ke, o, t, e)),
                  g = [c.className, t.className, h.className],
                  v = l({}, c.style, t.style, h.style),
                  y = {};

              if (t.expander) {
                var b = function b(t) {
                  if (V) return V(o.nestingPath, t);
                  var r = m.default.clone($);
                  return i ? e.setStateWithData({
                    expandedRows: m.default.set(r, o.nestingPath, !1)
                  }) : e.setStateWithData({
                    expandedRows: m.default.set(r, o.nestingPath, {})
                  });
                };

                if (y.onClick = b, t.pivotColumns) {
                  var C = t.pivotRender;
                  return f.default.createElement(re, l({
                    key: n,
                    className: (0, d.default)("rt-pivot", g),
                    style: l({}, v, {
                      paddingLeft: 1 === o.nestingPath.length ? void 0 : 30 * (o.nestingPath.length - 1) + "px",
                      flex: u + " 0 auto",
                      width: u + "px",
                      maxWidth: p + "px"
                    })
                  }, c.rest, {
                    onClick: b
                  }), o.subRows ? f.default.createElement("span", null, m.default.normalizeComponent(t.render, l({}, o, {
                    value: o.rowValues[t.id],
                    isExpanded: i
                  }), o.rowValues[t.id]), t && t.pivotRender ? f.default.createElement(C, l({}, o, {
                    value: o.rowValues[Q]
                  })) : f.default.createElement("span", null, r[Q], " (", o.subRows.length, ")")) : ie ? f.default.createElement("span", null, m.default.normalizeComponent(t.render, l({}, o, {
                    value: o.rowValues[t.id],
                    isExpanded: i
                  }), o.rowValues[t.id])) : null);
                }
              }

              return f.default.createElement(re, l({
                key: n,
                className: (0, d.default)(g, !s && "hidden"),
                style: l({}, v, {
                  flex: u + " 0 auto",
                  width: u + "px",
                  maxWidth: p + "px"
                })
              }, c.rest, y), m.default.normalizeComponent(t.render, l({}, o, {
                value: o.rowValues[t.id],
                isExpanded: i
              }), o.rowValues[t.id]));
            })), o.subRows && i && o.subRows.map(function (e, r) {
              return t(e, r, o.nestingPath);
            }), ie && !o.subRows && i && ie(o));
          },
              qe = function qe(t, r) {
            var n = x(ke, void 0, void 0, e),
                a = m.default.splitProps(E(ke, void 0, void 0, e));
            return f.default.createElement(Z, l({
              key: r
            }, n), f.default.createElement(ee, {
              className: (0, d.default)("-padRow", a.className),
              style: a.style || {}
            }, pe.map(function (t, r) {
              var n = H.find(function (e) {
                return e.id === t.id;
              }) || {},
                  a = "function" == typeof t.show ? t.show() : t.show,
                  o = m.default.getFirstDefined(n.value, t.width, t.minWidth),
                  i = m.default.getFirstDefined(n.value, t.width, t.maxWidth),
                  s = m.default.splitProps(S(ke, void 0, t, e)),
                  u = m.default.splitProps(t.getProps(ke, void 0, t, e)),
                  p = [s.className, t.className, u.className],
                  c = l({}, s.style, t.style, u.style);
              return f.default.createElement(re, l({
                key: r,
                className: (0, d.default)(p, !a && "hidden"),
                style: l({}, c, {
                  flex: o + " 0 auto",
                  width: o + "px",
                  maxWidth: i + "px"
                })
              }, s.rest), " ");
            })));
          },
              Le = function Le() {
            var t = k(ke, void 0, void 0, e),
                r = m.default.splitProps(P(ke, void 0, void 0, e));
            return f.default.createElement(ne, l({
              className: t.className,
              style: l({}, t.style, {
                minWidth: Ee + "px"
              })
            }, t.rest), f.default.createElement(ee, l({
              className: (0, d.default)(r.className),
              style: r.style
            }, r.rest), pe.map(function (t, r) {
              var n = H.find(function (e) {
                return e.id === t.id;
              }) || {},
                  a = "function" == typeof t.show ? t.show() : t.show,
                  o = m.default.getFirstDefined(n.value, t.width, t.minWidth),
                  i = m.default.getFirstDefined(n.value, t.width, t.maxWidth),
                  s = m.default.splitProps(T(ke, void 0, void 0, e)),
                  u = m.default.splitProps(t.getProps(ke, void 0, t, e)),
                  p = m.default.splitProps(t.getFooterProps(ke, void 0, t, e)),
                  c = [s.className, t.className, u.className, p.className],
                  h = l({}, s.style, t.style, u.style, p.style);
              return t.expander && t.pivotColumns ? f.default.createElement(re, l({
                key: r,
                className: (0, d.default)("rt-pivot", c),
                style: l({}, h, {
                  flex: o + " 0 auto",
                  width: o + "px",
                  maxWidth: i + "px"
                })
              }, u.rest, s.rest, p.rest), m.default.normalizeComponent(t.footer)) : f.default.createElement(re, l({
                key: r,
                className: (0, d.default)(c, !a && "hidden"),
                style: l({}, h, {
                  flex: o + " 0 auto",
                  width: o + "px",
                  maxWidth: i + "px"
                })
              }, u.rest, s.rest, p.rest), m.default.normalizeComponent(t.footer, {
                data: de,
                column: t
              }));
            })));
          },
              je = m.default.splitProps(o(ke, void 0, void 0, this)),
              De = m.default.splitProps(i(ke, void 0, void 0, this)),
              Ae = m.default.splitProps(w(ke, void 0, void 0, this)),
              Fe = m.default.splitProps(R(ke, void 0, void 0, this)),
              Ie = O(ke, void 0, void 0, this),
              We = z(ke, void 0, void 0, this),
              Ue = N(ke, void 0, void 0, this),
              Ke = function Ke() {
            return f.default.createElement("div", l({
              className: (0, d.default)("ReactTable", n, je.className),
              style: l({}, a, je.style)
            }, je.rest), f.default.createElement(X, l({
              className: (0, d.default)(De.className),
              style: De.style
            }, De.rest), ce ? Pe() : null, Re(), D ? ze() : null, f.default.createElement(J, l({
              className: (0, d.default)(Ae.className),
              style: l({}, Ae.style, {
                minWidth: Ee + "px"
              })
            }, Ae.rest), ge.map(function (e, t) {
              return Me(e, t);
            }), ye.map(qe)), be ? Le() : null), M ? f.default.createElement(ae, l({}, t, {
              pages: B,
              canPrevious: we,
              canNext: xe,
              onPageChange: e.onPageChange,
              onPageSizeChange: e.onPageSizeChange,
              className: Fe.className,
              style: Fe.style
            }, Fe.rest)) : null, !ge.length && f.default.createElement(se, We, m.default.normalizeComponent(j)), f.default.createElement(oe, l({
              loading: F,
              loadingText: L
            }, Ie)));
          };

          return r ? r(ke, Ke, this) : Ke();
        }
      }]), t;
    }((0, b.default)((0, v.default)(p.Component))));

    w.defaultProps = _.default, t.default = w;
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }();

    t.default = function (e) {
      return function (e) {
        function t() {
          return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }

        return o(t, e), i(t, [{
          key: "componentWillMount",
          value: function value() {
            this.setStateWithData(this.getDataModel(this.getResolvedState()));
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            this.fireOnChange();
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e, t) {
            var r = this.getResolvedState(),
                n = this.getResolvedState(e, t);
            r.defaultSorting !== n.defaultSorting && (n.sorting = n.defaultSorting), r.showFilters === n.showFilters && r.showFilters === n.showFilters || (n.filtering = n.defaultFiltering), r.data === n.data && r.columns === n.columns && r.pivotBy === n.pivotBy && r.sorting === n.sorting && r.showFilters === n.showFilters && r.filtering === n.filtering || this.setStateWithData(this.getDataModel(n));
          }
        }, {
          key: "setStateWithData",
          value: function value(e, t) {
            var r = this.getResolvedState(),
                n = this.getResolvedState({}, e),
                a = n.freezeWhenExpanded;
            if (n.frozen = !1, a) for (var o = Object.keys(n.expandedRows), i = 0; i < o.length; i++) {
              if (n.expandedRows[o[i]]) {
                n.frozen = !0;
                break;
              }
            }
            return (r.frozen && !n.frozen || r.sorting !== n.sorting || r.filtering !== n.filtering || r.showFilters !== n.showFilters || !n.frozen && r.resolvedData !== n.resolvedData) && ((r.sorting !== n.sorting && this.props.collapseOnSortingChange || r.filtering !== n.filtering || r.showFilters !== n.showFilters || !n.frozen && r.resolvedData !== n.resolvedData && this.props.collapseOnDataChange) && (n.expandedRows = {}), Object.assign(n, this.getSortedData(n))), n.sortedData && (n.pages = n.manual ? n.pages : Math.ceil(n.sortedData.length / n.pageSize), n.page = Math.max(n.page >= n.pages ? n.pages - 1 : n.page, 0)), this.setState(n, t);
          }
        }]), t;
      }(e);
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function a(e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = Array(e.length); t < e.length; t++) {
          r[t] = e[t];
        }

        return r;
      }

      return Array.from(e);
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function s(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        var r = [],
            n = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, s = e[Symbol.iterator](); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            !n && s.return && s.return();
          } finally {
            if (a) throw o;
          }
        }

        return r;
      }

      return function (t, r) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return e(t, r);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }(),
        u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        p = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        f = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        c = r(3),
        d = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(c);

    t.default = function (e) {
      return function (e) {
        function t() {
          return o(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }

        return s(t, e), f(t, [{
          key: "getResolvedState",
          value: function value(e, t) {
            return p({}, d.default.compactObject(this.state), d.default.compactObject(this.props), d.default.compactObject(t), d.default.compactObject(e));
          }
        }, {
          key: "getDataModel",
          value: function value(e) {
            var t = this,
                r = e.columns,
                o = e.pivotBy,
                i = void 0 === o ? [] : o,
                s = e.data,
                f = e.pivotIDKey,
                c = e.pivotValKey,
                h = e.subRowsKey,
                m = e.SubComponent,
                g = !1;
            r.forEach(function (e) {
              e.columns && (g = !0);
            });

            var v = [],
                y = [],
                b = function b(e) {
              var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e[0];
              v.push(p({}, t.props.column, r, {
                columns: e
              })), y = [];
            },
                C = [].concat(a(r)),
                _ = r.find(function (e) {
              return e.expander || e.columns && e.columns.some(function (e) {
                return e.expander;
              });
            });

            _ && !_.expander && (_ = _.columns.find(function (e) {
              return e.expander;
            })), !m && !i.length || _ || (_ = {
              expander: !0
            }, C = [_].concat(a(C)));

            var w = function w(e) {
              var r = void 0;

              if (r = i.length && e.expander ? p({}, t.props.column, {
                render: t.props.ExpanderComponent,
                filterRender: t.props.ExpanderComponent
              }, t.props.pivotDefaults, e) : e.expander ? p({}, t.props.column, {
                render: t.props.ExpanderComponent
              }, t.props.expanderDefaults, e) : p({}, t.props.column, e), "string" == typeof r.accessor) {
                var n = function () {
                  r.id = r.id || r.accessor;
                  var e = r.accessor;
                  return r.accessor = function (t) {
                    return d.default.get(t, e);
                  }, {
                    v: r
                  };
                }();

                if ("object" === (void 0 === n ? "undefined" : u(n))) return n.v;
              }

              if (r.accessor && !r.id) throw console.warn(r), new Error("A column id is required if using a non-string accessor for column above.");
              return r.accessor || (r.accessor = function (e) {}), r.maxWidth < r.minWidth && (r.minWidth = r.maxWidth), r;
            },
                x = function x(e) {
              var t = w(e);
              return E.push(t), t;
            },
                E = [],
                S = C.map(function (e, t) {
              return e.columns ? p({}, e, {
                columns: e.columns.map(x)
              }) : x(e);
            }),
                k = S.slice(),
                P = [];

            if (k = k.map(function (e, t) {
              if (e.columns) {
                var r = e.columns.filter(function (e) {
                  return !(i.indexOf(e.id) > -1) && d.default.getFirstDefined(e.show, !0);
                });
                return p({}, e, {
                  columns: r
                });
              }

              return e;
            }), k = k.filter(function (e) {
              return e.columns ? e.columns.length : !(i.indexOf(e.id) > -1) && d.default.getFirstDefined(e.show, !0);
            }), i.length) {
              for (var T = [], R = 0; R < E.length; R++) {
                i.indexOf(E[R].id) > -1 && T.push(E[R]);
              }

              var O = k.findIndex(function (e) {
                return e.expander || e.columns && e.columns.some(function (e) {
                  return e.expander;
                });
              });

              if (O >= 0) {
                var z = p({}, k[O], {
                  pivotColumns: T
                });
                k[O] = z;
              } else {
                var N = k[O].columns.findIndex(function (e) {
                  return e.expander;
                }),
                    M = p({}, k[O].columns[N], {
                  pivotColumns: T
                });
                k[O].columns[N] = M;
              }
            }

            k.forEach(function (e, t) {
              if (e.columns) return P = P.concat(e.columns), y.length > 0 && b(y), void b(e.columns, e);
              P.push(e), y.push(e);
            }), g && y.length > 0 && b(y);

            var q = s.map(function (e, t) {
              var r = {
                __original: e,
                __index: t
              };
              return E.forEach(function (t) {
                t.expander || (r[t.id] = t.accessor(e));
              }), r;
            }),
                L = function L(e) {
              var t = {};
              return j.forEach(function (r) {
                var n = e.map(function (e) {
                  return e[r.id];
                });
                t[r.id] = r.aggregate(n, e);
              }), t;
            },
                j = P.filter(function (e) {
              return !e.expander && e.aggregate;
            }),
                D = void 0;

            return i.length && function () {
              D = P[0];

              q = function e(t, r) {
                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                if (a === r.length) return t;
                var o = Object.entries(d.default.groupBy(t, r[a])).map(function (e) {
                  var t,
                      o = l(e, 2),
                      i = o[0],
                      s = o[1];
                  return t = {}, n(t, f, r[a]), n(t, c, i), n(t, r[a], i), n(t, h, s), t;
                });
                return o = o.map(function (t) {
                  var o = e(t[h], r, a + 1);
                  return p({}, t, n({}, h, o), L(o));
                });
              }(q, i);
            }(), p({}, e, {
              resolvedData: q,
              pivotColumn: D,
              allVisibleColumns: P,
              headerGroups: v,
              allDecoratedColumns: E,
              hasHeaderGroups: g
            });
          }
        }, {
          key: "getSortedData",
          value: function value(e) {
            var t = e.manual,
                r = e.sorting,
                n = e.filtering,
                a = e.showFilters,
                o = e.defaultFilterMethod,
                i = e.resolvedData,
                s = e.allVisibleColumns;
            return {
              sortedData: t ? i : this.sortData(this.filterData(i, a, n, o, s), r)
            };
          }
        }, {
          key: "fireOnChange",
          value: function value() {
            this.props.onChange(this.getResolvedState(), this);
          }
        }, {
          key: "getPropOrState",
          value: function value(e) {
            return d.default.getFirstDefined(this.props[e], this.state[e]);
          }
        }, {
          key: "getStateOrProp",
          value: function value(e) {
            return d.default.getFirstDefined(this.state[e], this.props[e]);
          }
        }, {
          key: "filterData",
          value: function value(e, t, r, a, o) {
            var i = this,
                s = e;
            return t && r.length && (s = r.reduce(function (e, t) {
              return e.filter(function (e) {
                var r = void 0;

                if (t.pivotId) {
                  r = o.find(function (e) {
                    return e.id === t.id;
                  }).pivotColumns.find(function (e) {
                    return e.id === t.pivotId;
                  });
                } else r = o.find(function (e) {
                  return e.id === t.id;
                });

                return (r.filterMethod || a)(t, e, r);
              });
            }, s), s = s.map(function (e) {
              return e[i.props.subRowsKey] ? p({}, e, n({}, i.props.subRowsKey, i.filterData(e[i.props.subRowsKey], t, r, a, o))) : e;
            }).filter(function (e) {
              return !e[i.props.subRowsKey] || e[i.props.subRowsKey].length > 0;
            })), s;
          }
        }, {
          key: "sortData",
          value: function value(e, t) {
            var r = this;
            return t.length ? d.default.orderBy(e, t.map(function (e) {
              return function (t) {
                return null === t[e.id] || void 0 === t[e.id] ? -1 / 0 : "string" == typeof t[e.id] ? t[e.id].toLowerCase() : t[e.id];
              };
            }), t.map(function (e) {
              return !e.desc;
            })).map(function (e) {
              return e[r.props.subRowsKey] ? p({}, e, n({}, r.props.subRowsKey, r.sortData(e[r.props.subRowsKey], t))) : e;
            }) : e;
          }
        }, {
          key: "getMinRows",
          value: function value() {
            return d.default.getFirstDefined(this.props.minRows, this.getStateOrProp("pageSize"));
          }
        }, {
          key: "onPageChange",
          value: function value(e) {
            var t = this,
                r = this.props,
                n = r.onPageChange,
                a = r.collapseOnPageChange;
            if (n) return n(e);
            var o = {
              page: e
            };
            a && (o.expandedRows = {}), this.setStateWithData(o, function () {
              t.fireOnChange();
            });
          }
        }, {
          key: "onPageSizeChange",
          value: function value(e) {
            var t = this,
                r = this.props.onPageSizeChange,
                n = this.getResolvedState(),
                a = n.pageSize,
                o = n.page,
                i = a * o,
                s = Math.floor(i / e);
            if (r) return r(e, s);
            this.setStateWithData({
              pageSize: e,
              page: s
            }, function () {
              t.fireOnChange();
            });
          }
        }, {
          key: "sortColumn",
          value: function value(e, t) {
            var r = this,
                n = this.getResolvedState(),
                a = n.sorting;
            if (n.skipNextSort) return void this.setStateWithData({
              skipNextSort: !1
            });
            var o = this.props.onSortingChange;
            if (o) return o(e, t);
            var i = d.default.clone(a || []).map(function (e) {
              return e.desc = d.default.isSortingDesc(e), e;
            });
            if (d.default.isArray(e)) !function () {
              var r = i.findIndex(function (t) {
                return t.id === e[0].id;
              });

              if (r > -1) {
                i[r].desc ? t ? i.splice(r, e.length) : e.forEach(function (e, t) {
                  i[r + t].desc = !1;
                }) : e.forEach(function (e, t) {
                  i[r + t].desc = !0;
                }), t || (i = i.slice(r, e.length));
              } else i = t ? i.concat(e.map(function (e) {
                return {
                  id: e.id,
                  desc: !1
                };
              })) : e.map(function (e) {
                return {
                  id: e.id,
                  desc: !1
                };
              });
            }();else {
              var s = i.findIndex(function (t) {
                return t.id === e.id;
              });

              if (s > -1) {
                var l = i[s];
                l.desc ? t ? i.splice(s, 1) : (l.desc = !1, i = [l]) : (l.desc = !0, t || (i = [l]));
              } else t ? i.push({
                id: e.id,
                desc: !1
              }) : i = [{
                id: e.id,
                desc: !1
              }];
            }
            this.setStateWithData({
              page: !a.length && i.length || !t ? 0 : this.state.page,
              sorting: i
            }, function () {
              r.fireOnChange();
            });
          }
        }, {
          key: "filterColumn",
          value: function value(e, t, r) {
            var n = this,
                a = this.getResolvedState(),
                o = a.filtering,
                i = this.props.onFilteringChange;
            if (i) return i(e, t, r);
            var s = (o || []).filter(function (t) {
              return t.id !== e.id || (t.pivotId ? !r || t.pivotId !== r.id : void 0);
            });
            "" !== t && s.push({
              id: e.id,
              value: t,
              pivotId: r ? r.id : void 0
            }), this.setStateWithData({
              filtering: s
            }, function () {
              n.fireOnChange();
            });
          }
        }, {
          key: "resizeColumnStart",
          value: function value(e, t, r) {
            var n = this,
                a = this.props.onResize;
            if (a) return a(e, t, r);
            var o = t.target.parentElement.getBoundingClientRect().width,
                i = void 0;
            i = r ? t.changedTouches[0].pageX : t.pageX, this.setStateWithData({
              currentlyResizing: {
                id: e.id,
                startX: i,
                parentWidth: o
              }
            }, function () {
              r ? (document.addEventListener("touchmove", n.resizeColumnMoving), document.addEventListener("touchcancel", n.resizeColumnEnd), document.addEventListener("touchend", n.resizeColumnEnd)) : (document.addEventListener("mousemove", n.resizeColumnMoving), document.addEventListener("mouseup", n.resizeColumnEnd), document.addEventListener("mouseleave", n.resizeColumnEnd));
            });
          }
        }, {
          key: "resizeColumnEnd",
          value: function value(e) {
            var t = "touchend" === e.type || "touchcancel" === e.type;
            t && (document.removeEventListener("touchmove", this.resizeColumnMoving), document.removeEventListener("touchcancel", this.resizeColumnEnd), document.removeEventListener("touchend", this.resizeColumnEnd)), document.removeEventListener("mousemove", this.resizeColumnMoving), document.removeEventListener("mouseup", this.resizeColumnEnd), document.removeEventListener("mouseleave", this.resizeColumnEnd), t || this.setStateWithData({
              skipNextSort: !0
            });
          }
        }, {
          key: "resizeColumnMoving",
          value: function value(e) {
            var t = this.getResolvedState(),
                r = t.resizing,
                n = t.currentlyResizing,
                a = r.filter(function (e) {
              return e.id !== n.id;
            }),
                o = void 0;
            "touchmove" === e.type ? o = e.changedTouches[0].pageX : "mousemove" === e.type && (o = e.pageX);
            var i = Math.max(n.parentWidth + o - n.startX, 11);
            a.push({
              id: n.id,
              value: i
            }), this.setStateWithData({
              resizing: a
            });
          }
        }]), t;
      }(e);
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        u = r(0),
        p = n(u),
        f = r(2),
        c = n(f),
        d = function d(e) {
      return p.default.createElement("button", l({
        type: "button"
      }, e, {
        className: "-btn"
      }), e.children);
    },
        h = function (e) {
      function t(e) {
        a(this, t);
        var r = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
        return r.getSafePage = r.getSafePage.bind(r), r.changePage = r.changePage.bind(r), r.applyPage = r.applyPage.bind(r), r.state = {
          page: e.page
        }, r;
      }

      return i(t, e), s(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.setState({
            page: e.page
          });
        }
      }, {
        key: "getSafePage",
        value: function value(e) {
          return isNaN(e) && (e = this.props.page), Math.min(Math.max(e, 0), this.props.pages - 1);
        }
      }, {
        key: "changePage",
        value: function value(e) {
          e = this.getSafePage(e), this.setState({
            page: e
          }), this.props.page !== e && this.props.onPageChange(e);
        }
      }, {
        key: "applyPage",
        value: function value(e) {
          e && e.preventDefault();
          var t = this.state.page;
          this.changePage("" === t ? this.props.page : t);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              r = t.pages,
              n = t.page,
              a = t.showPageSizeOptions,
              o = t.pageSizeOptions,
              i = t.pageSize,
              s = t.showPageJump,
              l = t.canPrevious,
              u = t.canNext,
              f = t.onPageSizeChange,
              h = t.className,
              m = t.PreviousComponent,
              g = void 0 === m ? d : m,
              v = t.NextComponent,
              y = void 0 === v ? d : v;
          return p.default.createElement("div", {
            className: (0, c.default)(h, "-pagination"),
            style: this.props.paginationStyle
          }, p.default.createElement("div", {
            className: "-previous"
          }, p.default.createElement(g, {
            onClick: function onClick(t) {
              l && e.changePage(n - 1);
            },
            disabled: !l
          }, this.props.previousText)), p.default.createElement("div", {
            className: "-center"
          }, p.default.createElement("span", {
            className: "-pageInfo"
          }, this.props.pageText, " ", s ? p.default.createElement("div", {
            className: "-pageJump"
          }, p.default.createElement("input", {
            type: "" === this.state.page ? "text" : "number",
            onChange: function onChange(t) {
              var r = t.target.value,
                  n = r - 1;
              if ("" === r) return e.setState({
                page: r
              });
              e.setState({
                page: e.getSafePage(n)
              });
            },
            value: "" === this.state.page ? "" : this.state.page + 1,
            onBlur: this.applyPage,
            onKeyPress: function onKeyPress(t) {
              13 !== t.which && 13 !== t.keyCode || e.applyPage();
            }
          })) : p.default.createElement("span", {
            className: "-currentPage"
          }, n + 1), " ", this.props.ofText, " ", p.default.createElement("span", {
            className: "-totalPages"
          }, r)), a && p.default.createElement("span", {
            className: "select-wrap -pageSizeOptions"
          }, p.default.createElement("select", {
            onChange: function onChange(e) {
              return f(Number(e.target.value));
            },
            value: i
          }, o.map(function (t, r) {
            return p.default.createElement("option", {
              key: r,
              value: t
            }, t, " ", e.props.rowsText);
          })))), p.default.createElement("div", {
            className: "-next"
          }, p.default.createElement(y, {
            onClick: function onClick(t) {
              u && e.changePage(n + 1);
            },
            disabled: !u
          }, this.props.nextText)));
        }
      }]), t;
    }(u.Component);

    t.default = h;
  }, function (e, t, r) {
    var n = r(13);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    r(5)(n, {});
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    var n = r(14);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    r(5)(n, {});
    n.locals && (e.exports = n.locals);
  },,,,,, function (e, t, r) {
    e.exports = r(7);
  }]);
});